<template>
  <div class="c1-main aff1-main c1-affiliation-page" @click="c1TopTab = null">

    <!-- TOAST -->
    <transition name="aff1-toast-fade">
      <div v-if="aff1Toast" class="aff1-toast" :style="{ background: aff1Toast.color }">{{ aff1Toast.msg }}</div>
    </transition>

    <!-- GOOGLE ADS SDK BANNER -->
    <div class="aff1-sdk-banner" v-if="showSdkBanner">
      <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
      <span>Google Ads provider unavailable — SDK not installed. Other providers active.</span>
      <button class="aff1-sdk-banner-close" @click="showSdkBanner = false">
        <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>

    <!-- TOP BAR -->
    <div class="c1-sticky-top">
    <div class="c1-tib" @click="c1SlideOpen = null; c1HamMenuOpen = false; c1ShiftMenuOpen = false; c1TopTab = null">
      <!-- LEFT 25% -->
      <div class="c1-tib-side c1-tib-left" style="padding-left:0;gap:8px;">
        <div class="c1-viki-topface"
          :class="{ 'c1-viki-topface--active': c1PanelActiveContent === 'viki' }"
          @click.stop="c1SelectPanel('viki','')"
        >
          <viki-face :mood="c1VikiMood" :speaking="c1VikiSpeaking" :size="44" style="width:72px;height:44px;display:block;overflow:hidden;border-radius:0;"/>
        </div>
        <div class="c1-shift-wrap" @click.stop="c1ShiftMenuOpen = !c1ShiftMenuOpen; c1HamMenuOpen = false">
          <div class="c1-tib-shift-pill" :class="{ open: c1ShiftMenuOpen }">
            ⏱ {{ c1ShiftElapsed }}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:10px;height:10px;margin-left:3px;transition:transform .2s" :style="{ transform: c1ShiftMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)' }"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>
      </div>
      <!-- CENTER 50% -->
      <div class="c1-tib-center">
        <div class="c1-tib-mod-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
          Affiliation
        </div>
      </div>
      <!-- RIGHT 25% — ham only -->
      <div class="c1-tib-side c1-tib-right">
        <div class="c1-ham-wrap" @click.stop>
          <button class="c1-ham-btn" :class="{ open: c1HamMenuOpen }" @click="c1HamMenuOpen = !c1HamMenuOpen; c1ShiftMenuOpen = false">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>
        </div>
      </div>
    </div>
    <!-- SHIFT DRAWER -->
    <div class="c1-top-drawer c1-shift-drawer" :class="{ open: c1ShiftMenuOpen }" @click.stop>
      <div class="c1-td-inner">
        <div class="c1-td-section-lbl">My Shift</div>
        <div class="c1-td-status-row">
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono">{{ c1ShiftStartTime ? new Date(c1ShiftStartTime).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : '—' }}</div>
            <div class="c1-td-stat-lbl">Started</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono" style="color:var(--c1-dp)">{{ c1ShiftElapsed }}</div>
            <div class="c1-td-stat-lbl">Elapsed</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1BathroomCount }}×</div>
            <div class="c1-td-stat-lbl">🚽 Bathroom</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1CoffeeCount }}×</div>
            <div class="c1-td-stat-lbl">☕ Coffee</div>
          </div>
        </div>
        <div class="c1-td-btn-row">
          <button class="c1-td-btn c1-td-btn-shift"   :class="{ active: c1Status === 'shift' }"   @click.stop="c1SetStatus('shift')">▶ On Shift</button>
          <button class="c1-td-btn c1-td-btn-bathroom" :class="{ active: c1Status === 'bathroom' }" @click.stop="c1SetStatus('bathroom')">🚽 Bathroom</button>
          <button class="c1-td-btn c1-td-btn-coffee"  :class="{ active: c1Status === 'coffee' }"  @click.stop="c1SetStatus('coffee')">☕ Coffee</button>
          <button class="c1-td-btn c1-td-btn-break"   :class="{ active: c1Status === 'break' }"   @click.stop="c1SetStatus('break')">⏸ Break</button>
          <button class="c1-td-btn c1-td-btn-lunch"   :class="{ active: c1Status === 'lunch' }"   @click.stop="c1SetStatus('lunch')">🍽 Lunch</button>
          <button class="c1-td-btn c1-td-btn-end"     @click.stop="c1SetStatus('end')">⏹ End Shift</button>
        </div>
      </div>
    </div>
    <!-- HAM NAV DRAWER -->
    <div class="c1-top-drawer c1-ham-drawer" :class="{ open: c1HamMenuOpen }" @click.stop>
      <div class="c1-td-inner c1-td-nav-grid">
        <router-link to="/clients1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-dp)"></span>Clients</router-link>
        <router-link to="/tasks1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-sc)"></span>Tasks</router-link>
        <router-link to="/stats1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-ld)"></span>Statistics</router-link>
        <router-link to="/chat1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-rf)"></span>Chat</router-link>
        <router-link to="/communications1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#3b82f6"></span>Communications</router-link>
        <router-link to="/affiliation1" class="c1-td-nav-item" :class="{ on: $route.path === '/affiliation1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#8b5cf6"></span>Affiliation</router-link>
        <router-link to="/finance1" class="c1-td-nav-item" :class="{ on: $route.path === '/finance1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#10b981"></span>Finance</router-link>
        <router-link to="/shifts1" class="c1-td-nav-item" :class="{ on: $route.path === '/shifts1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#f59e0b"></span>Shifts</router-link>
        <router-link to="/users1" class="c1-td-nav-item" :class="{ on: $route.path === '/users1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#06b6d4"></span>Users</router-link>
        <router-link to="/brokers1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ec4899"></span>Brokers</router-link>
        <router-link to="/security1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ef4444"></span>Security</router-link>
        <router-link to="/quiz1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#a78bfa"></span>Quiz</router-link>
        <router-link to="/instruction1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#64748b"></span>Instructions</router-link>
        <router-link to="/settings1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#94a3b8"></span>Settings</router-link>
        <router-link to="/profile1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#22d3ee"></span>My Profile</router-link>
      </div>
    </div>
    </div><!-- /c1-sticky-top -->

    <!-- TOP STRIP -->
    <div class="c1-top-strip c1-mod-strip" @click.stop>
      <div class="c1-top-strip-body">
        <div class="c1-ts-tab-row">

          <!-- View tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'view'}" @click.stop="c1TopTab = c1TopTab === 'view' ? null : 'view'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>
            <span>{{ viewMode === 'inbound' ? 'Inbound' : 'Outbound' }}</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='view' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>

          <!-- Provider tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'provider'}" @click.stop="c1TopTab = c1TopTab === 'provider' ? null : 'provider'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
            <span>Provider</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='provider' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>

          <!-- Campaign tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'campaign'}" @click.stop="c1TopTab = c1TopTab === 'campaign' ? null : 'campaign'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
            <span>Campaign</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='campaign' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>

          <!-- Status tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'status'}" @click.stop="c1TopTab = c1TopTab === 'status' ? null : 'status'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            <span>Status</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='status' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>

          <!-- Date tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'date'}" @click.stop="c1TopTab = c1TopTab === 'date' ? null : 'date'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            <span>Date</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='date' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>

          <!-- Click Type tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'clicktype'}" @click.stop="c1TopTab = c1TopTab === 'clicktype' ? null : 'clicktype'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><path d="M5 3l14 9-14 9V3z"/></svg>
            <span>Click type</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='clicktype' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>

        </div>

        <!-- View dropdown -->
        <div v-show="c1TopTab === 'view'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-lbl">View mode</div>
          <div class="c1-fp-opts">
            <div class="c1-fp-opt" :class="{ on: viewMode === 'inbound' }" @click="viewMode = 'inbound'">
              <svg viewBox="0 0 24 24" style="width:11px;height:11px;stroke:currentColor;fill:none;stroke-width:2"><polyline points="8 17 3 12 8 7"/><line x1="21" y1="12" x2="3" y2="12"/></svg>
              Inbound
            </div>
            <div class="c1-fp-opt" :class="{ on: viewMode === 'outbound' }" @click="viewMode = 'outbound'">
              Outbound
              <svg viewBox="0 0 24 24" style="width:11px;height:11px;stroke:currentColor;fill:none;stroke-width:2"><polyline points="16 17 21 12 16 7"/><line x1="3" y1="12" x2="21" y2="12"/></svg>
            </div>
          </div>
        </div>

        <!-- Provider dropdown -->
        <div v-show="c1TopTab === 'provider'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-lbl">Provider</div>
          <div v-if="providersError" class="aff1-sdk-inline">
            <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            Google Ads SDK unavailable — showing active providers only
          </div>
          <div class="c1-fp-opts" style="margin-top:6px">
            <div class="c1-fp-opt" :class="{ on: filters.providers.length === 0 }" @click="filters.providers = []; applyFilters()">All</div>
            <div
              v-for="p in allProviders"
              :key="p.id"
              class="c1-fp-opt aff1-provider-chip"
              :class="{ on: filters.providers.includes(p.id), 'aff1-prov-mock': p.isMock }"
              @click="toggleProviderFilter(p.id)"
            >
              <span v-if="p.logo" class="aff1-prov-logo">{{ p.logo }}</span>
              {{ p.name }}
              <span v-if="p.isMock" class="aff1-mock-tag">mock</span>
            </div>
          </div>
        </div>

        <!-- Campaign dropdown -->
        <div v-show="c1TopTab === 'campaign'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-lbl">Campaign</div>
          <div class="c1-fp-search">
            <svg class="c1-fp-sico" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input class="c1-fp-sinput" v-model.trim="filters.campaign" placeholder="Campaign name or ID…" @input="applyFilters()" />
            <div v-if="filters.campaign" class="c1-fp-sclear" @click="filters.campaign = ''; applyFilters()">
              <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
          <div class="c1-fp-lbl" style="margin-top:10px">Country</div>
          <div class="c1-fp-search">
            <svg class="c1-fp-sico" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input class="c1-fp-sinput" v-model.trim="filters.country" placeholder="e.g. GB, DE, US…" @input="applyFilters()" />
            <div v-if="filters.country" class="c1-fp-sclear" @click="filters.country = ''; applyFilters()">
              <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
        </div>

        <!-- Status dropdown -->
        <div v-show="c1TopTab === 'status'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-lbl">Status</div>
          <div class="c1-fp-opts">
            <div class="c1-fp-opt" :class="{ on: !filters.status }" @click="filters.status = null; applyFilters()">All</div>
            <div class="c1-fp-opt aff1-chip-active" :class="{ on: filters.status === 'active' }" @click="filters.status = 'active'; applyFilters()">Active</div>
            <div class="c1-fp-opt aff1-chip-paused" :class="{ on: filters.status === 'paused' }" @click="filters.status = 'paused'; applyFilters()">Paused</div>
            <div class="c1-fp-opt aff1-chip-completed" :class="{ on: filters.status === 'completed' }" @click="filters.status = 'completed'; applyFilters()">Completed</div>
            <div class="c1-fp-opt aff1-chip-unique" :class="{ on: filters.status === 'unique' }" @click="filters.status = 'unique'; applyFilters()">Unique <span class="c1-fc">{{ summary.unique }}</span></div>
            <div class="c1-fp-opt aff1-chip-dup" :class="{ on: filters.status === 'duplicate' }" @click="filters.status = 'duplicate'; applyFilters()">Duplicate <span class="c1-fc">{{ summary.duplicate }}</span></div>
            <div class="c1-fp-opt aff1-chip-conv" :class="{ on: filters.status === 'converted' }" @click="filters.status = 'converted'; applyFilters()">Converted <span class="c1-fc">{{ summary.converted }}</span></div>
          </div>
        </div>

        <!-- Date dropdown -->
        <div v-show="c1TopTab === 'date'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-lbl">Date range</div>
          <div class="c1-fp-opts">
            <div class="c1-fp-opt" :class="{ on: filters.dateRange === 'T' }" @click="setDateFilter('T')">T</div>
            <div class="c1-fp-opt" :class="{ on: filters.dateRange === 'Y' }" @click="setDateFilter('Y')">Y</div>
            <div class="c1-fp-opt" :class="{ on: filters.dateRange === 'TW' }" @click="setDateFilter('TW')">TW</div>
            <div class="c1-fp-opt" :class="{ on: filters.dateRange === 'LW' }" @click="setDateFilter('LW')">LW</div>
            <div class="c1-fp-opt" :class="{ on: filters.dateRange === 'TM' }" @click="setDateFilter('TM')">TM</div>
            <div class="c1-fp-opt" :class="{ on: filters.dateRange === 'LM' }" @click="setDateFilter('LM')">LM</div>
            <div class="c1-fp-opt" :class="{ on: filters.dateRange === 'ALL' }" @click="setDateFilter('ALL')">ALL</div>
          </div>
          <div class="c1-date-range-row" style="margin-top:8px">
            <input type="date" class="c1-date-input" v-model="filters.dateFrom" @change="filters.dateRange = 'custom'; applyFilters()" />
            <span class="c1-date-sep">→</span>
            <input type="date" class="c1-date-input" v-model="filters.dateTo" @change="filters.dateRange = 'custom'; applyFilters()" />
          </div>
        </div>

        <!-- Click Type dropdown -->
        <div v-show="c1TopTab === 'clicktype'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-lbl">Click type</div>
          <div class="c1-fp-opts">
            <div class="c1-fp-opt" :class="{ on: !filters.click_type }" @click="filters.click_type = null; applyFilters()">All</div>
            <div class="c1-fp-opt" :class="{ on: filters.click_type === 'organic' }" @click="filters.click_type = 'organic'; applyFilters()">Organic</div>
            <div class="c1-fp-opt" :class="{ on: filters.click_type === 'paid' }" @click="filters.click_type = 'paid'; applyFilters()">Paid</div>
            <div class="c1-fp-opt" :class="{ on: filters.click_type === 'referral' }" @click="filters.click_type = 'referral'; applyFilters()">Referral</div>
          </div>
        </div>

        <div class="c1-nm-div"></div>
        <c1-mod-calendar :items="clicks" dateField="created_at" itemLabel="records" style="flex-shrink:0" />

      </div>
    </div>
    <!-- /TOP STRIP -->

    <!-- PANEL BACKDROP -->
    <transition name="c1-bd-fade">
      <div v-if="c1SlideOpen" class="c1-panel-backdrop" @click.stop="c1SlideOpen = null"></div>
    </transition>

    <!-- ===== UNIFIED PANEL ===== -->
    <div class="c1-panel" :class="{ 'c1-panel--open': c1PanelIsOpen }" @click.capture="c1FilterPanelClick">
      <div class="c1-panel-track" :class="{ 'at-content': c1PanelAtContent }">

        <!-- SCREEN 0: NAV -->
        <div class="c1-panel-screen">
          <!-- User strip -->
          <div class="c1-nav-user-strip">
            <div class="c1-nav-av">
              {{ c1UserInitials }}
              <span class="c1-nav-av-dot" :class="'c1-dst-' + c1Status"></span>
            </div>
            <div class="c1-nav-uinfo">
              <div class="c1-nav-uname">{{ c1UserFullName }}</div>
              <div class="c1-nav-urole">{{ c1RoleLabel }}</div>
            </div>
            <div class="c1-nav-status-wrap" @click.stop="c1StatusMenuOpen = !c1StatusMenuOpen">
              <div class="c1-nav-status-btn" :class="'c1-st-' + c1Status">
                <span class="c1-nav-status-sdot"></span>
                <span class="c1-nav-status-elapsed">{{ c1StatusElapsed }}</span>
              </div>
              <transition name="c1-sfade">
                <div v-if="c1StatusMenuOpen" class="c1-nav-status-menu">
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('available')"><span class="c1-nav-status-opt-dot c1-st-dot-available"></span>Available</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('bathroom')"><span class="c1-nav-status-opt-dot c1-st-dot-bathroom"></span>Bathroom</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('coffee')"><span class="c1-nav-status-opt-dot c1-st-dot-coffee"></span>Coffee break</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('shift')"><span class="c1-nav-status-opt-dot c1-st-dot-shift"></span>Start shift</div>
                  <div class="c1-nav-status-opt c1-sto-end" @click.stop="c1SetStatus('end')"><span class="c1-nav-status-opt-dot c1-st-dot-end"></span>End shift</div>
                </div>
              </transition>
            </div>
          </div>

          <!-- Timezone bar -->
          <div class="c1-nav-tz-bar">
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇬🇧</span><span class="c1-nav-tz-time">{{ c1TzUK }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇮🇱</span><span class="c1-nav-tz-time">{{ c1TzIL }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🏝</span><span class="c1-nav-tz-time">{{ c1TzCB }}</span></div>
          </div>

          <!-- ── NAVIGATE: all pages ── -->
          <div v-if="c1NavMode === 'navigate'" class="c1-sl-body" style="padding:6px 0 12px">
            <div class="c1-psel-sub c1-psel-sub-back" @click.stop="c1NavMode = 'panels'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><polyline points="15 18 9 12 15 6"/></svg>
              <span class="c1-psel-sub-lbl">{{ c1CurrentPageLabel }}</span>
            <span class="c1-nav-x-btn" @click.stop="c1SlideOpen = null"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:15px;height:15px;display:block"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></span></div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">CRM</div>
            <router-link class="c1-psel-sub" to="/clients1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Clients</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/tasks1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Tasks</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/stats1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Statistics</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/chat1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Chat</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/communications1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Communications</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/affiliation1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Affiliation</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Sales</div>
            <router-link class="c1-psel-sub" to="/finance1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Finance</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/shifts1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Shifts</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/games1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Games</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Team</div>
            <router-link class="c1-psel-sub" to="/users1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Users</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/brokers1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Brokers</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/security1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Security</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Admin</div>
            <router-link class="c1-psel-sub" to="/quiz1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Quiz</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/instruction1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Instructions</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/settings1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Settings</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/profile1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">My Profile</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
          </div>

          <!-- ── PANELS MODE ── -->
          <div v-else class="c1-sl-body" style="padding:6px 0 12px">
            <!-- Navigate row -->
            <div class="c1-psel-sub c1-psel-sub-navigate" @click.stop="c1NavMode = 'navigate'">
              <span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span>
              <span class="c1-psel-sub-lbl" style="font-weight:600;color:var(--c1-dp)">{{ c1CurrentPageLabel }}</span>
              <span class="c1-psel-sub-hint">Go to another page</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
              Filters
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'filters' }" @click.stop="c1SelectPanel('filters','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Affiliate Filters</span>
              <span class="c1-psel-sub-hint">Provider, status, date, country</span>
              <svg v-if="c1PanelActiveContent === 'filters'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
              Analytics
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'charts' }" @click.stop="c1SelectPanel('charts','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Analytics</span>
              <span class="c1-psel-sub-hint">Clicks, conversions, CPL trends</span>
              <svg v-if="c1PanelActiveContent === 'charts'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Calendar
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'calendar' }" @click.stop="c1SelectPanel('calendar','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Calendar</span>
              <span class="c1-psel-sub-hint">Click activity by day</span>
              <svg v-if="c1PanelActiveContent === 'calendar'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
              Viki
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'viki' }" @click.stop="c1SelectPanel('viki','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Viki Alerts</span>
              <span class="c1-psel-sub-hint">Affiliate AI notifications</span>
              <svg v-if="c1PanelActiveContent === 'viki'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
          </div><!-- end v-else panels -->
        </div>

        <!-- SCREEN 1: CONTENT -->
        <div class="c1-panel-screen">
          <div class="c1-panel-hdr-bar">
            <div class="c1-panel-back-btn" @click="c1SlideOpen = 'nav'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            </div>
            <span class="c1-panel-hdr-ttl">{{ c1ActivePanelLabel }}</span>
            <div class="c1-panel-back-btn" @click="c1SlideOpen = null">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
          <div class="c1-sl-body">

            <!-- ===== FILTERS CONTENT ===== -->
            <template v-if="c1PanelActiveContent === 'filters'">
              <div v-if="activeFilterCount" class="c1-reset-bar" @click="resetFilters()">
                <svg viewBox="0 0 24 24"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
                Reset all filters
                <span class="c1-reset-bar-count">{{ activeFilterCount }}</span>
              </div>
              <div class="c1-sl-body">

        <!-- Provider multi-select -->
        <div class="c1-fp-group c1-fp-full">
          <div class="c1-fp-lbl">Provider</div>
          <div v-if="providersError" class="aff1-sdk-inline">
            <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            Google Ads SDK unavailable — showing active providers only
          </div>
          <div class="c1-fp-opts" style="margin-top:6px">
            <div class="c1-fp-opt" :class="{ on: filters.providers.length === 0 }" @click="filters.providers = []; applyFilters()">All</div>
            <div
              v-for="p in allProviders"
              :key="p.id"
              class="c1-fp-opt aff1-provider-chip"
              :class="{ on: filters.providers.includes(p.id), 'aff1-prov-mock': p.isMock }"
              @click="toggleProviderFilter(p.id)"
            >
              <span v-if="p.logo" class="aff1-prov-logo">{{ p.logo }}</span>
              {{ p.name }}
              <span v-if="p.isMock" class="aff1-mock-tag">mock</span>
            </div>
          </div>
        </div>

        <!-- Campaign filter -->
        <div class="c1-fp-group c1-fp-full">
          <div class="c1-fp-lbl">Campaign</div>
          <div class="c1-fp-search">
            <svg class="c1-fp-sico" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input class="c1-fp-sinput" v-model.trim="filters.campaign" placeholder="Campaign name or ID…" @input="applyFilters()" />
            <div v-if="filters.campaign" class="c1-fp-sclear" @click="filters.campaign = ''; applyFilters()">
              <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
        </div>

        <!-- Click type -->
        <div class="c1-fp-group">
          <div class="c1-fp-lbl">Click type</div>
          <div class="c1-fp-opts">
            <div class="c1-fp-opt" :class="{ on: !filters.click_type }" @click="filters.click_type = null; applyFilters()">All</div>
            <div class="c1-fp-opt" :class="{ on: filters.click_type === 'organic' }" @click="filters.click_type = 'organic'; applyFilters()">Organic</div>
            <div class="c1-fp-opt" :class="{ on: filters.click_type === 'paid' }" @click="filters.click_type = 'paid'; applyFilters()">Paid</div>
            <div class="c1-fp-opt" :class="{ on: filters.click_type === 'referral' }" @click="filters.click_type = 'referral'; applyFilters()">Referral</div>
          </div>
        </div>

        <!-- Status -->
        <div class="c1-fp-group">
          <div class="c1-fp-lbl">Status</div>
          <div class="c1-fp-opts">
            <div class="c1-fp-opt" :class="{ on: !filters.status }" @click="filters.status = null; applyFilters()">All</div>
            <div class="c1-fp-opt aff1-chip-active" :class="{ on: filters.status === 'active' }" @click="filters.status = 'active'; applyFilters()">Active</div>
            <div class="c1-fp-opt aff1-chip-paused" :class="{ on: filters.status === 'paused' }" @click="filters.status = 'paused'; applyFilters()">Paused</div>
            <div class="c1-fp-opt aff1-chip-completed" :class="{ on: filters.status === 'completed' }" @click="filters.status = 'completed'; applyFilters()">Completed</div>
            <div class="c1-fp-opt aff1-chip-unique" :class="{ on: filters.status === 'unique' }" @click="filters.status = 'unique'; applyFilters()">Unique <span class="c1-fc">{{ summary.unique }}</span></div>
            <div class="c1-fp-opt aff1-chip-dup" :class="{ on: filters.status === 'duplicate' }" @click="filters.status = 'duplicate'; applyFilters()">Duplicate <span class="c1-fc">{{ summary.duplicate }}</span></div>
            <div class="c1-fp-opt aff1-chip-conv" :class="{ on: filters.status === 'converted' }" @click="filters.status = 'converted'; applyFilters()">Converted <span class="c1-fc">{{ summary.converted }}</span></div>
          </div>
        </div>

        <!-- Country -->
        <div class="c1-fp-group c1-fp-full">
          <div class="c1-fp-lbl">Country</div>
          <div class="c1-fp-search">
            <svg class="c1-fp-sico" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input class="c1-fp-sinput" v-model.trim="filters.country" placeholder="e.g. GB, DE, US…" @input="applyFilters()" />
            <div v-if="filters.country" class="c1-fp-sclear" @click="filters.country = ''; applyFilters()">
              <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
        </div>

        <!-- Date range -->
        <div class="c1-fp-group c1-fp-full">
          <div class="c1-fp-lbl">Date range</div>
          <div class="c1-fp-opts">
            <div class="c1-fp-opt" :class="{ on: filters.dateRange === 'T' }" @click="setDateFilter('T')">T</div>
            <div class="c1-fp-opt" :class="{ on: filters.dateRange === 'Y' }" @click="setDateFilter('Y')">Y</div>
            <div class="c1-fp-opt" :class="{ on: filters.dateRange === 'TW' }" @click="setDateFilter('TW')">TW</div>
            <div class="c1-fp-opt" :class="{ on: filters.dateRange === 'LW' }" @click="setDateFilter('LW')">LW</div>
            <div class="c1-fp-opt" :class="{ on: filters.dateRange === 'TM' }" @click="setDateFilter('TM')">TM</div>
            <div class="c1-fp-opt" :class="{ on: filters.dateRange === 'LM' }" @click="setDateFilter('LM')">LM</div>
            <div class="c1-fp-opt" :class="{ on: filters.dateRange === 'ALL' }" @click="setDateFilter('ALL')">ALL</div>
          </div>
          <div class="c1-date-range-row" style="margin-top:8px">
            <input type="date" class="c1-date-input" v-model="filters.dateFrom" @change="filters.dateRange = 'custom'; applyFilters()" />
            <span class="c1-date-sep">→</span>
            <input type="date" class="c1-date-input" v-model="filters.dateTo" @change="filters.dateRange = 'custom'; applyFilters()" />
          </div>
        </div>

              </div>
            </template>

            <!-- ===== CHARTS CONTENT ===== -->
            <template v-if="c1PanelActiveContent === 'charts'">
              <div class="c1-sl-body">

        <!-- Clicks by provider donut -->
        <div class="c1-co-lbl">Clicks by Provider</div>
        <div class="aff1-donut-wrap">
          <svg class="aff1-donut-svg" viewBox="0 0 120 120">
            <circle cx="60" cy="60" r="48" fill="none" stroke="var(--c1-brd)" stroke-width="18"/>
            <circle
              v-for="(seg, i) in donutSegments"
              :key="'ds-' + i"
              cx="60" cy="60" r="48"
              fill="none"
              :stroke="seg.color"
              stroke-width="18"
              :stroke-dasharray="seg.dash"
              :stroke-dashoffset="seg.offset"
              transform="rotate(-90 60 60)"
            />
          </svg>
          <div class="aff1-donut-center">
            <div class="aff1-donut-total">{{ summary.total }}</div>
            <div class="aff1-donut-lbl">total</div>
          </div>
        </div>
        <div class="aff1-donut-legend">
          <div v-for="(seg, i) in donutSegments" :key="'dl-' + i" class="aff1-donut-leg-item">
            <span class="aff1-donut-leg-dot" :style="{ background: seg.color }"></span>
            <span class="aff1-donut-leg-name">{{ seg.label }}</span>
            <span class="aff1-donut-leg-val">{{ seg.val }}</span>
          </div>
        </div>

        <!-- Conversion rate bar chart -->
        <div class="c1-co-lbl" style="margin-top:16px">Conversion Rate by Provider</div>
        <div class="c1-vbar-chart">
          <div v-for="bar in chartBarsConv" :key="'cv-' + bar.label" class="c1-vbar-row">
            <div class="c1-vbar-lbl">{{ bar.label }}</div>
            <div class="c1-vbar-track">
              <div class="c1-vbar-fill aff1-bar-conv" :style="{ width: bar.pct + '%' }">
                <span class="c1-vbar-val">{{ bar.val }}%</span>
              </div>
            </div>
          </div>
          <div v-if="!chartBarsConv.length" class="aff1-chart-empty">No conversion data</div>
        </div>

        <!-- Cost per lead trend -->
        <div class="c1-co-lbl" style="margin-top:16px">Cost Per Lead Trend (7d)</div>
        <div class="aff1-line-chart">
          <svg :viewBox="'0 0 ' + cplChart.w + ' ' + cplChart.h" preserveAspectRatio="none">
            <polyline v-if="cplChart.points" :points="cplChart.points" fill="none" stroke="#f59e0b" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"/>
            <circle v-for="pt in cplChart.dots" :key="'cp-' + pt.x" :cx="pt.x" :cy="pt.y" r="3" fill="#f59e0b"/>
          </svg>
          <div class="aff1-line-labels">
            <span v-for="(d, i) in dailyClickData" :key="'cpl-' + i" class="aff1-line-lbl">{{ d.label }}</span>
          </div>
          <div v-if="!dailyClickData.length" class="aff1-chart-empty">No data</div>
        </div>

        <!-- Daily click volume line -->
        <div class="c1-co-lbl" style="margin-top:16px">Daily Click Volume (7d)</div>
        <div class="aff1-line-chart">
          <svg :viewBox="'0 0 ' + lineChart.w + ' ' + lineChart.h" preserveAspectRatio="none">
            <polyline :points="lineChart.points" fill="none" stroke="#6366f1" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"/>
            <circle v-for="pt in lineChart.dots" :key="'lc-' + pt.x" :cx="pt.x" :cy="pt.y" r="3" fill="#6366f1"/>
          </svg>
          <div class="aff1-line-labels">
            <span v-for="(d, i) in dailyClickData" :key="'dl-' + i" class="aff1-line-lbl">{{ d.label }}</span>
          </div>
          <div v-if="!dailyClickData.length" class="aff1-chart-empty">No data</div>
        </div>

        <!-- Referral timeline -->
        <div class="c1-co-lbl" style="margin-top:16px">Referral Timeline</div>
        <div class="aff1-referral-timeline">
          <div v-for="(event, i) in referralTimeline" :key="'rt-' + i" class="aff1-rtl-item">
            <div class="aff1-rtl-dot" :style="{ background: event.color }"></div>
            <div class="aff1-rtl-body">
              <div class="aff1-rtl-title">{{ event.title }}</div>
              <div class="aff1-rtl-sub">{{ event.sub }}</div>
            </div>
            <div class="aff1-rtl-time">{{ event.time }}</div>
          </div>
          <div v-if="!referralTimeline.length" class="aff1-chart-empty">No referral events</div>
        </div>

              </div>
            </template>

            <!-- ===== CALENDAR CONTENT ===== -->
            <template v-if="c1PanelActiveContent === 'calendar'">
              <div class="c1-sl-body">
        <div class="aff1-cal-hdr">
          <button class="aff1-cal-nav" @click="calPrevMonth()">
            <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
          </button>
          <div class="aff1-cal-title">{{ calMonthNames[cal.month] }} {{ cal.year }}</div>
          <button class="aff1-cal-nav" @click="calNextMonth()">
            <svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
          </button>
        </div>
        <div class="aff1-cal-dow">
          <span v-for="d in ['Mo','Tu','We','Th','Fr','Sa','Su']" :key="d">{{ d }}</span>
        </div>
        <div class="aff1-cal-grid">
          <template v-for="(week, wi) in calGrid" :key="'cw-' + wi">
            <div
              v-for="day in week"
              :key="day.date"
              class="aff1-cal-day"
              :class="{
                'other-month': !day.inMonth,
                'today': day.today,
                'selected': day.date === calSelectedDate,
                'heat-high': calHeat(day.date) === 'high',
                'heat-mid': calHeat(day.date) === 'mid',
                'heat-low': calHeat(day.date) === 'low'
              }"
              @click="calSelectDay(day.date)"
            >
              <span>{{ day.day }}</span>
              <div v-if="calDayHasActivity(day.date)" class="aff1-cal-dot"></div>
            </div>
          </template>
        </div>
        <!-- Day detail -->
        <div v-if="calSelectedDate" class="aff1-cal-day-detail">
          <div class="c1-co-lbl" style="margin-bottom:8px">{{ calSelectedDate }}</div>
          <div class="aff1-cal-day-kpis">
            <div class="aff1-cal-dk">
              <div class="aff1-cal-dk-val">{{ calDayClicks(calSelectedDate).length }}</div>
              <div class="aff1-cal-dk-lbl">Clicks</div>
            </div>
            <div class="aff1-cal-dk">
              <div class="aff1-cal-dk-val aff1-kpi-conv">{{ calDayConverted(calSelectedDate) }}</div>
              <div class="aff1-cal-dk-lbl">Converted</div>
            </div>
            <div class="aff1-cal-dk">
              <div class="aff1-cal-dk-val aff1-kpi-rate">{{ calDayConvRate(calSelectedDate) }}%</div>
              <div class="aff1-cal-dk-lbl">Conv. rate</div>
            </div>
          </div>
          <div v-if="calDayClicks(calSelectedDate).length === 0" class="aff1-chart-empty">No affiliate activity this day</div>
          <div v-for="click in calDayClicks(calSelectedDate).slice(0, 15)" :key="'cald-' + click.id" class="aff1-cal-click-row">
            <span class="aff1-provider-chip-sm">{{ click.provider || '—' }}</span>
            <span class="aff1-mono">{{ fmtTime(click.created_at) }}</span>
            <span class="aff1-status-badge" :class="'aff1-s-' + click.status">{{ click.status }}</span>
          </div>
          <div v-if="calDayClicks(calSelectedDate).length > 15" class="aff1-chart-empty">+{{ calDayClicks(calSelectedDate).length - 15 }} more…</div>
        </div>
              </div>
            </template>

            <!-- ===== VIKI CONTENT ===== -->
            <template v-if="c1PanelActiveContent === 'viki'">
              <div class="c1-sl-body">
        <div v-if="vikiNotifs.length === 0" class="aff1-chart-empty" style="padding:16px 0">No alerts at this time.</div>
        <div v-for="(notif, i) in vikiNotifs" :key="'vk-' + i" class="aff1-viki-card" :class="'aff1-viki-' + notif.type">
          <div class="aff1-viki-icon">
            <svg v-if="notif.type === 'lead'" viewBox="0 0 24 24"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
            <svg v-else-if="notif.type === 'alert'" viewBox="0 0 24 24"><polygon points="10.29 3 1.45 18 23 18"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
            <svg v-else viewBox="0 0 24 24"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
          </div>
          <div class="aff1-viki-body">
            <div class="aff1-viki-msg">{{ notif.msg }}</div>
            <div class="aff1-viki-time">{{ notif.time }}</div>
          </div>
          <button class="aff1-viki-dismiss" @click="vikiNotifs.splice(i, 1)">
            <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
              </div>
            </template>

          </div>
        </div>

      </div>
    </div>

    <!-- ===== VIEW MODE LABEL ===== -->
    <div class="aff1-view-mode-bar">
      <div v-if="viewMode === 'inbound'" class="aff1-vm-pill aff1-vm-in">
        <svg viewBox="0 0 24 24"><polyline points="8 17 3 12 8 7"/><line x1="21" y1="12" x2="3" y2="12"/></svg>
        Inside Traffic — Leads coming IN from affiliate sources
      </div>
      <div v-else class="aff1-vm-pill aff1-vm-out">
        <svg viewBox="0 0 24 24"><polyline points="16 17 21 12 16 7"/><line x1="3" y1="12" x2="21" y2="12"/></svg>
        Outside Information — Performance data going OUT to affiliates
      </div>
      <button class="aff1-add-prov-btn" @click="openAddProviderDrawer()">
        <svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
        Add Provider
      </button>
    </div>

    <!-- ===== SUMMARY STRIP ===== -->
    <div class="aff1-summary-strip">
      <div class="aff1-kpi">
        <div class="aff1-kpi-val">{{ summary.total_today }}</div>
        <div class="aff1-kpi-lbl">Clicks today</div>
      </div>
      <div class="aff1-kpi">
        <div class="aff1-kpi-val aff1-kpi-unique">{{ summary.unique }}</div>
        <div class="aff1-kpi-lbl">Unique</div>
      </div>
      <div class="aff1-kpi">
        <div class="aff1-kpi-val aff1-kpi-conv">{{ summary.converted }}</div>
        <div class="aff1-kpi-lbl">Converted</div>
      </div>
      <div class="aff1-kpi">
        <div class="aff1-kpi-val aff1-kpi-rate">{{ summary.convRate }}%</div>
        <div class="aff1-kpi-lbl">Conv. rate</div>
      </div>
      <div class="aff1-kpi">
        <div class="aff1-kpi-val" style="font-size:13px;color:var(--c1-sc)">{{ summary.avg_cpl ? '$' + summary.avg_cpl : '—' }}</div>
        <div class="aff1-kpi-lbl">Avg. CPL</div>
      </div>
      <div class="aff1-kpi aff1-kpi-provider">
        <div class="aff1-kpi-val aff1-kpi-prov-name">{{ summary.top_provider || '—' }}</div>
        <div class="aff1-kpi-lbl">Top provider</div>
      </div>
    </div>

    <!-- ===== MAIN CONTENT ===== -->
    <div v-if="!loading">

      <!-- INBOUND VIEW — provider accordion table -->
      <div v-if="viewMode === 'inbound'" class="aff1-provider-table">

        <!-- Table header -->
        <div class="aff1-pt-hdr">
          <div class="aff1-pt-hc aff1-pt-hc-prov">Provider</div>
          <div class="aff1-pt-hc">Clicks</div>
          <div class="aff1-pt-hc">Leads</div>
          <div class="aff1-pt-hc">Conv. %</div>
          <div class="aff1-pt-hc">CPL</div>
          <div class="aff1-pt-hc aff1-pt-hc-chv"></div>
        </div>

        <!-- Provider accordion rows -->
        <div v-for="prov in providerRows" :key="'pr-' + prov.id" class="aff1-pt-block" :class="{ expanded: expandedProvider === prov.id }">

          <!-- Collapsed provider row -->
          <div class="aff1-pt-row" @click="toggleProviderExpand(prov.id)">
            <div class="aff1-pt-c aff1-pt-c-prov">
              <span class="aff1-prov-logo-lg">{{ prov.logo }}</span>
              <div class="aff1-prov-info">
                <div class="aff1-prov-name">{{ prov.name }}</div>
                <div class="aff1-prov-type">{{ prov.type }}</div>
              </div>
              <span v-if="prov.isMock" class="aff1-mock-badge">mock</span>
              <span v-if="prov.status === 'paused'" class="aff1-prov-status-pill aff1-ps-paused">paused</span>
              <span v-else-if="prov.status === 'active'" class="aff1-prov-status-pill aff1-ps-active">active</span>
            </div>
            <div class="aff1-pt-c aff1-pt-c-num">{{ prov.clicks_today }}</div>
            <div class="aff1-pt-c aff1-pt-c-num">{{ prov.leads_today }}</div>
            <div class="aff1-pt-c aff1-pt-c-num" :class="prov.conv_rate >= 5 ? 'aff1-kpi-conv' : prov.conv_rate >= 2 ? 'aff1-kpi-rate' : ''">{{ prov.conv_rate }}%</div>
            <div class="aff1-pt-c aff1-pt-c-num" :class="prov.cpl_spike ? 'aff1-cpl-spike' : ''">
              ${{ prov.cost_per_lead }}
              <span v-if="prov.cpl_spike" class="aff1-spike-arrow">↑{{ prov.cpl_spike }}%</span>
            </div>
            <div class="aff1-pt-c aff1-pt-c-chv">
              <svg class="aff1-chv" :class="{ open: expandedProvider === prov.id }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </div>
          </div>

          <!-- Expanded provider detail -->
          <div v-if="expandedProvider === prov.id" class="aff1-pt-expanded">

            <!-- Tabs: Campaigns / Keywords / Cost Analysis -->
            <div class="aff1-exp-tabs">
              <div class="aff1-exp-tab" :class="{ on: providerTab === 'campaigns' }" @click.stop="providerTab = 'campaigns'">Campaigns</div>
              <div class="aff1-exp-tab" :class="{ on: providerTab === 'keywords' }" @click.stop="providerTab = 'keywords'">Keywords</div>
              <div class="aff1-exp-tab" :class="{ on: providerTab === 'cost' }" @click.stop="providerTab = 'cost'">Cost Analysis</div>
              <div class="aff1-exp-tab" :class="{ on: providerTab === 'trend' }" @click.stop="providerTab = 'trend'">Daily Trend</div>
            </div>

            <!-- Campaign breakdown -->
            <div v-if="providerTab === 'campaigns'" class="aff1-sub-table">
              <div class="aff1-sub-hdr">
                <div class="aff1-sub-hc" style="flex:2">Campaign</div>
                <div class="aff1-sub-hc">Clicks</div>
                <div class="aff1-sub-hc">Leads</div>
                <div class="aff1-sub-hc">Conv.%</div>
                <div class="aff1-sub-hc">CPL</div>
              </div>
              <div v-for="(camp, ci) in prov.campaigns" :key="'camp-' + ci" class="aff1-sub-row">
                <div class="aff1-sub-c aff1-sub-c-name" style="flex:2">
                  <span class="aff1-camp-dot"></span>
                  {{ camp.name }}
                </div>
                <div class="aff1-sub-c">{{ camp.clicks }}</div>
                <div class="aff1-sub-c">{{ camp.leads }}</div>
                <div class="aff1-sub-c" :class="camp.conv_pct >= 5 ? 'aff1-kpi-conv' : ''">{{ camp.conv_pct }}%</div>
                <div class="aff1-sub-c">${{ camp.cpl }}</div>
              </div>
              <div v-if="!prov.campaigns || !prov.campaigns.length" class="aff1-chart-empty" style="padding:10px 12px">No campaign data</div>
            </div>

            <!-- Keyword breakdown top 20 -->
            <div v-if="providerTab === 'keywords'" class="aff1-sub-table">
              <div class="aff1-sub-hdr">
                <div class="aff1-sub-hc" style="flex:3">Keyword</div>
                <div class="aff1-sub-hc">Clicks</div>
                <div class="aff1-sub-hc">Conv.%</div>
                <div class="aff1-sub-hc">CPC</div>
              </div>
              <div v-for="(kw, ki) in (prov.keywords || []).slice(0, 20)" :key="'kw-' + ki" class="aff1-sub-row">
                <div class="aff1-sub-c aff1-sub-c-kw" style="flex:3">
                  <span class="aff1-kw-rank">{{ ki + 1 }}</span>
                  {{ kw.keyword }}
                </div>
                <div class="aff1-sub-c">{{ kw.clicks }}</div>
                <div class="aff1-sub-c" :class="kw.conv_pct >= 5 ? 'aff1-kpi-conv' : ''">{{ kw.conv_pct }}%</div>
                <div class="aff1-sub-c">${{ kw.cpc }}</div>
              </div>
              <div v-if="!prov.keywords || !prov.keywords.length" class="aff1-chart-empty" style="padding:10px 12px">No keyword data</div>
            </div>

            <!-- Cost analysis -->
            <div v-if="providerTab === 'cost'" class="aff1-cost-panel">
              <div class="aff1-cost-kpi-row">
                <div class="aff1-cost-kpi">
                  <div class="aff1-cost-kpi-val aff1-color-spend">${{ prov.total_spend || 0 }}</div>
                  <div class="aff1-cost-kpi-lbl">Total Spend</div>
                </div>
                <div class="aff1-cost-kpi">
                  <div class="aff1-cost-kpi-val aff1-kpi-conv">${{ prov.total_revenue || 0 }}</div>
                  <div class="aff1-cost-kpi-lbl">Revenue from Leads</div>
                </div>
                <div class="aff1-cost-kpi">
                  <div class="aff1-cost-kpi-val" :class="prov.roi >= 0 ? 'aff1-kpi-conv' : 'aff1-color-spend'">{{ prov.roi >= 0 ? '+' : '' }}{{ prov.roi || 0 }}%</div>
                  <div class="aff1-cost-kpi-lbl">ROI</div>
                </div>
                <div class="aff1-cost-kpi">
                  <div class="aff1-cost-kpi-val">${{ prov.budget_cap || '—' }}</div>
                  <div class="aff1-cost-kpi-lbl">Budget Cap</div>
                </div>
              </div>
              <div class="aff1-cost-bar-wrap">
                <div class="aff1-cost-bar-lbl">Spend vs Revenue</div>
                <div class="aff1-cost-comparison">
                  <div class="aff1-cost-track">
                    <div class="aff1-cost-fill aff1-cost-spend-fill" :style="{ width: costSpendPct(prov) + '%' }"></div>
                  </div>
                  <div class="aff1-cost-track">
                    <div class="aff1-cost-fill aff1-cost-rev-fill" :style="{ width: costRevPct(prov) + '%' }"></div>
                  </div>
                </div>
                <div class="aff1-cost-legend">
                  <span><span class="aff1-cost-leg-dot aff1-color-spend-dot"></span>Spend</span>
                  <span><span class="aff1-cost-leg-dot aff1-color-rev-dot"></span>Revenue</span>
                </div>
              </div>
            </div>

            <!-- Daily trend for this provider -->
            <div v-if="providerTab === 'trend'" class="aff1-trend-panel">
              <div class="aff1-line-chart">
                <svg :viewBox="'0 0 300 60'" preserveAspectRatio="none">
                  <polyline :points="providerTrendPoints(prov)" fill="none" stroke="#6366f1" stroke-width="2" stroke-linejoin="round"/>
                </svg>
                <div class="aff1-line-labels">
                  <span v-for="(d, i) in dailyClickData" :key="'pt-' + i" class="aff1-line-lbl">{{ d.label }}</span>
                </div>
              </div>
            </div>

            <!-- Actions -->
            <div class="aff1-pt-actions">
              <button class="aff1-action-btn aff1-action-detail" @click.stop="openProviderDetailDrawer(prov)">
                <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                Full detail
              </button>
              <button class="aff1-action-btn aff1-action-provider" @click.stop="openEditProviderDrawer(prov)">
                <svg viewBox="0 0 24 24"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
                Edit
              </button>
              <button class="aff1-action-btn" @click.stop="openPixelDrawer(prov)">
                <svg viewBox="0 0 24 24"><path d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"/></svg>
                Pixel
              </button>
            </div>
          </div>

        </div>

        <!-- Empty provider state -->
        <div v-if="providerRows.length === 0" class="aff1-empty">
          <div class="aff1-empty-icon">
            <svg viewBox="0 0 24 24"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
          </div>
          <div class="aff1-empty-msg">No providers found</div>
          <div class="aff1-empty-sub">Add a provider to start tracking affiliate traffic</div>
        </div>

        <!-- Referral tracking section -->
        <div class="aff1-section-divider">
          <span>Referral Tracking</span>
        </div>

        <div class="aff1-referral-section">
          <div class="aff1-referral-hdr">
            <div class="aff1-referral-hdr-ttl">Agent Referral Performance</div>
            <div class="aff1-referral-hdr-sub">Which agents' clients are referring new leads</div>
          </div>
          <div v-for="(ref, ri) in referralAgents" :key="'ref-' + ri" class="aff1-ref-row">
            <div class="aff1-ref-av">{{ ref.initials }}</div>
            <div class="aff1-ref-info">
              <div class="aff1-ref-name">{{ ref.name }}</div>
              <div class="aff1-ref-chain">{{ ref.chain }}</div>
            </div>
            <div class="aff1-ref-stats">
              <div class="aff1-ref-stat">
                <div class="aff1-ref-stat-val aff1-kpi-conv">{{ ref.referrals }}</div>
                <div class="aff1-ref-stat-lbl">Referrals</div>
              </div>
              <div class="aff1-ref-stat">
                <div class="aff1-ref-stat-val" style="color:var(--c1-sc)">${{ ref.bonus }}</div>
                <div class="aff1-ref-stat-lbl">Bonus</div>
              </div>
            </div>
          </div>
          <div v-if="!referralAgents.length" class="aff1-chart-empty" style="padding:16px 12px">No referral data available</div>
        </div>

        <!-- Pixel Tracker Section -->
        <div class="aff1-section-divider">
          <span>Pixel Tracker</span>
        </div>

        <div class="aff1-pixel-section">
          <div class="aff1-pixel-hdr-row">
            <div class="aff1-pixel-hdr-info">
              <div class="aff1-pixel-hdr-ttl">Tracking Pixels</div>
              <div class="aff1-pixel-hdr-sub">Embed on your landing pages to track affiliate traffic</div>
            </div>
            <button class="aff1-action-btn" @click="openPixelDrawer(null)">
              <svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              Generate pixel
            </button>
          </div>
          <div v-for="px in pixelTrackers" :key="'px-' + px.provider_id" class="aff1-pixel-row">
            <div class="aff1-pixel-row-prov">
              <span class="aff1-prov-logo-lg">{{ px.logo }}</span>
              <div class="aff1-pixel-row-info">
                <div class="aff1-pixel-row-name">{{ px.provider_name }}</div>
                <div class="aff1-mono" style="font-size:9px;color:var(--c1-t3);word-break:break-all">{{ px.snippet }}</div>
              </div>
            </div>
            <div class="aff1-pixel-row-stats">
              <div class="aff1-px-stat">
                <span class="aff1-px-dot" :class="px.active ? 'aff1-px-active' : 'aff1-px-inactive'"></span>
                {{ px.active ? 'Active' : 'Inactive' }}
              </div>
              <div class="aff1-px-stat aff1-kpi-conv">{{ px.fired_today }} fired today</div>
            </div>
            <button class="aff1-copy-btn" @click="copyPixelSnippet(px)">
              <svg viewBox="0 0 24 24"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
              {{ px.copied ? 'Copied!' : 'Copy' }}
            </button>
          </div>
          <div v-if="!pixelTrackers.length" class="aff1-chart-empty" style="padding:16px 12px">No pixels configured yet</div>
        </div>

      </div>

      <!-- OUTBOUND VIEW — click data list -->
      <div v-else class="aff1-list">

        <!-- Click rows accordion -->
        <div
          v-for="click in filteredClicks"
          :key="'cl-' + click.id"
          class="aff1-box"
          :class="{ expanded: expandedId === click.id }"
        >
          <div class="aff1-row" @click="toggleExpand(click.id)">
            <div class="aff1-col-ts">
              <span class="aff1-mono">{{ fmtTime(click.created_at) }}</span>
              <span class="aff1-ago">{{ timeAgo(click.created_at) }}</span>
            </div>
            <div class="aff1-col-prov">
              <span class="aff1-provider-chip-sm">{{ click.provider || '—' }}</span>
            </div>
            <div class="aff1-col-type">
              <span class="aff1-type-badge" :class="'aff1-ct-' + (click.click_type || 'organic')">{{ click.click_type || 'organic' }}</span>
            </div>
            <div class="aff1-col-ip">
              <span class="aff1-mono aff1-ip">{{ click.ip || '—' }}</span>
              <span class="aff1-flag">{{ countryFlag(click.country_code) }}</span>
            </div>
            <div class="aff1-col-status">
              <span class="aff1-status-badge" :class="'aff1-s-' + click.status">{{ click.status || 'unique' }}</span>
            </div>
            <div class="aff1-col-chv">
              <svg class="aff1-chv" :class="{ open: expandedId === click.id }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </div>
          </div>

          <div v-if="expandedId === click.id" class="aff1-expanded">
            <div class="aff1-exp-sec">
              <div class="aff1-exp-lbl">Referral Data</div>
              <div class="aff1-exp-grid">
                <div class="aff1-ef"><div class="aff1-ef-l">Click ID</div><div class="aff1-ef-v aff1-mono">#{{ click.id }}</div></div>
                <div class="aff1-ef"><div class="aff1-ef-l">Timestamp</div><div class="aff1-ef-v aff1-mono">{{ fmtFull(click.created_at) }}</div></div>
                <div class="aff1-ef"><div class="aff1-ef-l">Provider</div><div class="aff1-ef-v"><span class="aff1-provider-chip-sm">{{ click.provider || '—' }}</span></div></div>
                <div class="aff1-ef"><div class="aff1-ef-l">Click type</div><div class="aff1-ef-v"><span class="aff1-type-badge" :class="'aff1-ct-' + (click.click_type || 'organic')">{{ click.click_type || 'organic' }}</span></div></div>
                <div class="aff1-ef"><div class="aff1-ef-l">IP</div><div class="aff1-ef-v aff1-mono">{{ click.ip || '—' }}</div></div>
                <div class="aff1-ef"><div class="aff1-ef-l">Country</div><div class="aff1-ef-v">{{ countryFlag(click.country_code) }} {{ click.country_code || '—' }}</div></div>
                <div class="aff1-ef"><div class="aff1-ef-l">Status</div><div class="aff1-ef-v"><span class="aff1-status-badge" :class="'aff1-s-' + click.status">{{ click.status || 'unique' }}</span></div></div>
              </div>
            </div>
            <div v-if="click.utm_source || click.utm_campaign" class="aff1-exp-sec">
              <div class="aff1-exp-lbl">UTM Parameters</div>
              <div class="aff1-exp-grid">
                <div v-if="click.utm_source" class="aff1-ef"><div class="aff1-ef-l">utm_source</div><div class="aff1-ef-v aff1-mono">{{ click.utm_source }}</div></div>
                <div v-if="click.utm_medium" class="aff1-ef"><div class="aff1-ef-l">utm_medium</div><div class="aff1-ef-v aff1-mono">{{ click.utm_medium }}</div></div>
                <div v-if="click.utm_campaign" class="aff1-ef aff1-ef-full"><div class="aff1-ef-l">utm_campaign</div><div class="aff1-ef-v aff1-mono">{{ click.utm_campaign }}</div></div>
                <div v-if="click.utm_content" class="aff1-ef aff1-ef-full"><div class="aff1-ef-l">utm_content</div><div class="aff1-ef-v aff1-mono">{{ click.utm_content }}</div></div>
                <div v-if="click.utm_term" class="aff1-ef"><div class="aff1-ef-l">utm_term</div><div class="aff1-ef-v aff1-mono">{{ click.utm_term }}</div></div>
              </div>
            </div>
            <div v-if="click.aaid || click.url" class="aff1-exp-sec">
              <div class="aff1-exp-lbl">Tracking</div>
              <div class="aff1-exp-grid">
                <div v-if="click.aaid" class="aff1-ef aff1-ef-full"><div class="aff1-ef-l">A-AID</div><div class="aff1-ef-v aff1-mono" style="word-break:break-all;font-size:10px">{{ click.aaid }}</div></div>
                <div v-if="click.url" class="aff1-ef aff1-ef-full"><div class="aff1-ef-l">URL</div><div class="aff1-ef-v aff1-mono" style="word-break:break-all;font-size:10px">{{ click.url }}</div></div>
              </div>
            </div>
            <div v-if="click.status === 'converted' && click.client" class="aff1-exp-sec aff1-exp-sec-conv">
              <div class="aff1-exp-lbl aff1-exp-lbl-conv">Converted Client</div>
              <div class="aff1-exp-grid">
                <div class="aff1-ef aff1-ef-full"><div class="aff1-ef-l">Name</div><div class="aff1-ef-v" style="font-weight:600">{{ click.client.first_name }} {{ click.client.last_name }}</div></div>
                <div class="aff1-ef"><div class="aff1-ef-l">ID</div><div class="aff1-ef-v aff1-mono">#{{ click.client.id }}</div></div>
                <div v-if="click.client.email" class="aff1-ef aff1-ef-full"><div class="aff1-ef-l">Email</div><div class="aff1-ef-v aff1-mono" style="font-size:10px">{{ click.client.email }}</div></div>
              </div>
            </div>
            <div class="aff1-exp-actions">
              <button class="aff1-action-btn aff1-action-detail" @click.stop="openDetailDrawer(click)">
                <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                Full detail
              </button>
              <button class="aff1-action-btn aff1-action-provider" @click.stop="openProviderDetailDrawerByName(click.provider)">
                <svg viewBox="0 0 24 24"><path d="M20 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="2"/></svg>
                Provider
              </button>
            </div>
          </div>
        </div>

        <div v-if="filteredClicks.length === 0" class="aff1-empty">
          <div class="aff1-empty-icon">
            <svg viewBox="0 0 24 24"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
          </div>
          <div class="aff1-empty-msg">No affiliate clicks found</div>
          <div class="aff1-empty-sub">Try adjusting your filters or date range</div>
        </div>

      </div>

    </div>

    <!-- Loading state -->
    <div v-else class="c1-loading">
      <div class="c1-spinner"></div>
      <div class="aff1-loading-lbl">Loading affiliate data…</div>
    </div>

    <!-- ===== RIGHT DRAWER — click detail ===== -->
    <transition name="aff1-drawer">
      <div v-if="detailDrawer.open && detailDrawer.click" class="aff1-drawer-wrap" @click.self="detailDrawer.open = false">
        <div class="aff1-drawer">
          <div class="aff1-drawer-head">
            <div class="aff1-drawer-av">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
            </div>
            <div class="aff1-drawer-title">
              <div class="aff1-drawer-name">Click #{{ detailDrawer.click.id }}</div>
              <div class="aff1-drawer-sub">{{ detailDrawer.click.provider || 'Unknown' }} · {{ fmtFull(detailDrawer.click.created_at) }}</div>
            </div>
            <button class="aff1-drawer-close" @click="detailDrawer.open = false">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
          <div class="aff1-drawer-body">
            <div class="aff1-exp-sec">
              <div class="aff1-exp-lbl">Click Event</div>
              <div class="aff1-exp-grid">
                <div class="aff1-ef"><div class="aff1-ef-l">ID</div><div class="aff1-ef-v aff1-mono">#{{ detailDrawer.click.id }}</div></div>
                <div class="aff1-ef"><div class="aff1-ef-l">Timestamp</div><div class="aff1-ef-v aff1-mono">{{ fmtFull(detailDrawer.click.created_at) }}</div></div>
                <div class="aff1-ef"><div class="aff1-ef-l">IP</div><div class="aff1-ef-v aff1-mono">{{ detailDrawer.click.ip || '—' }}</div></div>
                <div class="aff1-ef"><div class="aff1-ef-l">Country</div><div class="aff1-ef-v">{{ countryFlag(detailDrawer.click.country_code) }} {{ detailDrawer.click.country_code || '—' }}</div></div>
                <div class="aff1-ef"><div class="aff1-ef-l">Status</div><div class="aff1-ef-v"><span class="aff1-status-badge" :class="'aff1-s-' + detailDrawer.click.status">{{ detailDrawer.click.status }}</span></div></div>
                <div class="aff1-ef"><div class="aff1-ef-l">Type</div><div class="aff1-ef-v"><span class="aff1-type-badge" :class="'aff1-ct-' + (detailDrawer.click.click_type || 'organic')">{{ detailDrawer.click.click_type || 'organic' }}</span></div></div>
              </div>
            </div>
            <div v-if="detailDrawer.click.utm_source || detailDrawer.click.utm_campaign" class="aff1-exp-sec">
              <div class="aff1-exp-lbl">UTM Parameters</div>
              <div class="aff1-exp-grid">
                <div v-if="detailDrawer.click.utm_source" class="aff1-ef"><div class="aff1-ef-l">Source</div><div class="aff1-ef-v aff1-mono">{{ detailDrawer.click.utm_source }}</div></div>
                <div v-if="detailDrawer.click.utm_medium" class="aff1-ef"><div class="aff1-ef-l">Medium</div><div class="aff1-ef-v aff1-mono">{{ detailDrawer.click.utm_medium }}</div></div>
                <div v-if="detailDrawer.click.utm_campaign" class="aff1-ef aff1-ef-full"><div class="aff1-ef-l">Campaign</div><div class="aff1-ef-v aff1-mono">{{ detailDrawer.click.utm_campaign }}</div></div>
                <div v-if="detailDrawer.click.utm_content" class="aff1-ef aff1-ef-full"><div class="aff1-ef-l">Content</div><div class="aff1-ef-v aff1-mono">{{ detailDrawer.click.utm_content }}</div></div>
                <div v-if="detailDrawer.click.utm_term" class="aff1-ef"><div class="aff1-ef-l">Term</div><div class="aff1-ef-v aff1-mono">{{ detailDrawer.click.utm_term }}</div></div>
              </div>
            </div>
            <div v-if="detailDrawer.click.aaid || detailDrawer.click.url" class="aff1-exp-sec">
              <div class="aff1-exp-lbl">Tracking IDs</div>
              <div class="aff1-exp-grid">
                <div v-if="detailDrawer.click.aaid" class="aff1-ef aff1-ef-full"><div class="aff1-ef-l">A-AID</div><div class="aff1-ef-v aff1-mono" style="font-size:10px;word-break:break-all">{{ detailDrawer.click.aaid }}</div></div>
                <div v-if="detailDrawer.click.url" class="aff1-ef aff1-ef-full"><div class="aff1-ef-l">URL</div><div class="aff1-ef-v aff1-mono" style="font-size:10px;word-break:break-all">{{ detailDrawer.click.url }}</div></div>
              </div>
            </div>
            <div class="aff1-exp-sec">
              <div class="aff1-exp-lbl">Provider Performance</div>
              <div v-if="detailDrawer.providerStats" class="aff1-exp-grid">
                <div class="aff1-ef"><div class="aff1-ef-l">Total clicks</div><div class="aff1-ef-v" style="font-weight:700">{{ detailDrawer.providerStats.total }}</div></div>
                <div class="aff1-ef"><div class="aff1-ef-l">Unique</div><div class="aff1-ef-v aff1-kpi-unique" style="font-weight:700">{{ detailDrawer.providerStats.unique }}</div></div>
                <div class="aff1-ef"><div class="aff1-ef-l">Converted</div><div class="aff1-ef-v aff1-kpi-conv" style="font-weight:700">{{ detailDrawer.providerStats.converted }}</div></div>
                <div class="aff1-ef"><div class="aff1-ef-l">Conv. rate</div><div class="aff1-ef-v aff1-kpi-rate" style="font-weight:700">{{ detailDrawer.providerStats.rate }}%</div></div>
              </div>
              <div v-else class="aff1-chart-empty">No provider stats</div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- ===== RIGHT DRAWER — provider full detail ===== -->
    <transition name="aff1-drawer">
      <div v-if="provDetailDrawer.open && provDetailDrawer.prov" class="aff1-drawer-wrap" @click.self="provDetailDrawer.open = false">
        <div class="aff1-drawer">
          <div class="aff1-drawer-head">
            <div class="aff1-drawer-av aff1-drawer-av-prov">
              <span style="font-size:20px">{{ provDetailDrawer.prov.logo }}</span>
            </div>
            <div class="aff1-drawer-title">
              <div class="aff1-drawer-name">{{ provDetailDrawer.prov.name }}</div>
              <div class="aff1-drawer-sub">{{ provDetailDrawer.prov.type }} · {{ provDetailDrawer.prov.status }}</div>
            </div>
            <button class="aff1-drawer-close" @click="provDetailDrawer.open = false">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
          <div class="aff1-drawer-body">
            <!-- Full stats -->
            <div class="aff1-exp-sec">
              <div class="aff1-exp-lbl">Provider Stats</div>
              <div class="aff1-exp-grid">
                <div class="aff1-ef"><div class="aff1-ef-l">Clicks today</div><div class="aff1-ef-v" style="font-weight:700">{{ provDetailDrawer.prov.clicks_today }}</div></div>
                <div class="aff1-ef"><div class="aff1-ef-l">Leads today</div><div class="aff1-ef-v aff1-kpi-conv" style="font-weight:700">{{ provDetailDrawer.prov.leads_today }}</div></div>
                <div class="aff1-ef"><div class="aff1-ef-l">Conv. rate</div><div class="aff1-ef-v aff1-kpi-rate" style="font-weight:700">{{ provDetailDrawer.prov.conv_rate }}%</div></div>
                <div class="aff1-ef"><div class="aff1-ef-l">Cost / Lead</div><div class="aff1-ef-v" style="font-weight:700">${{ provDetailDrawer.prov.cost_per_lead }}</div></div>
                <div class="aff1-ef"><div class="aff1-ef-l">Total Spend</div><div class="aff1-ef-v aff1-color-spend" style="font-weight:700">${{ provDetailDrawer.prov.total_spend || 0 }}</div></div>
                <div class="aff1-ef"><div class="aff1-ef-l">Revenue</div><div class="aff1-ef-v aff1-kpi-conv" style="font-weight:700">${{ provDetailDrawer.prov.total_revenue || 0 }}</div></div>
              </div>
            </div>
            <!-- Campaign table -->
            <div class="aff1-exp-sec">
              <div class="aff1-exp-lbl">Campaign Breakdown</div>
              <div class="aff1-sub-table">
                <div class="aff1-sub-hdr">
                  <div class="aff1-sub-hc" style="flex:2">Campaign</div>
                  <div class="aff1-sub-hc">Clicks</div>
                  <div class="aff1-sub-hc">Conv.%</div>
                  <div class="aff1-sub-hc">CPL</div>
                </div>
                <div v-for="(camp, ci) in (provDetailDrawer.prov.campaigns || [])" :key="'drc-' + ci" class="aff1-sub-row">
                  <div class="aff1-sub-c" style="flex:2">{{ camp.name }}</div>
                  <div class="aff1-sub-c">{{ camp.clicks }}</div>
                  <div class="aff1-sub-c">{{ camp.conv_pct }}%</div>
                  <div class="aff1-sub-c">${{ camp.cpl }}</div>
                </div>
                <div v-if="!(provDetailDrawer.prov.campaigns || []).length" class="aff1-chart-empty" style="padding:10px 12px">No campaigns</div>
              </div>
            </div>
            <!-- Top keywords -->
            <div class="aff1-exp-sec">
              <div class="aff1-exp-lbl">Top Keywords (20)</div>
              <div class="aff1-sub-table">
                <div class="aff1-sub-hdr">
                  <div class="aff1-sub-hc" style="flex:3">Keyword</div>
                  <div class="aff1-sub-hc">Clicks</div>
                  <div class="aff1-sub-hc">CPC</div>
                </div>
                <div v-for="(kw, ki) in (provDetailDrawer.prov.keywords || []).slice(0, 20)" :key="'drkw-' + ki" class="aff1-sub-row">
                  <div class="aff1-sub-c" style="flex:3">
                    <span class="aff1-kw-rank">{{ ki + 1 }}</span>{{ kw.keyword }}
                  </div>
                  <div class="aff1-sub-c">{{ kw.clicks }}</div>
                  <div class="aff1-sub-c">${{ kw.cpc }}</div>
                </div>
                <div v-if="!(provDetailDrawer.prov.keywords || []).length" class="aff1-chart-empty" style="padding:10px 12px">No keyword data</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- ===== LEFT DRAWER — add/edit provider ===== -->
    <transition name="aff1-drawer-left">
      <div v-if="addProviderDrawer.open" class="aff1-drawer-wrap aff1-drawer-left-variant" @click.self="addProviderDrawer.open = false">
        <div class="aff1-drawer aff1-drawer-left">
          <div class="aff1-drawer-head">
            <div class="aff1-drawer-av aff1-drawer-av-prov">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M20 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="2"/></svg>
            </div>
            <div class="aff1-drawer-title">
              <div class="aff1-drawer-name">{{ addProviderDrawer.editMode ? 'Edit Provider' : 'Add Provider' }}</div>
              <div class="aff1-drawer-sub">{{ addProviderDrawer.editMode ? addProviderDrawer.form.name : 'New affiliate source' }}</div>
            </div>
            <button class="aff1-drawer-close" @click="addProviderDrawer.open = false">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
          <div class="aff1-drawer-body">
            <div class="aff1-exp-sec">
              <div class="aff1-exp-lbl">Provider Details</div>
              <div class="aff1-form-group">
                <label class="aff1-form-lbl">Provider name</label>
                <input class="aff1-form-input" v-model="addProviderDrawer.form.name" placeholder="e.g. Google Ads, Facebook, Taboola…" />
              </div>
              <div class="aff1-form-group">
                <label class="aff1-form-lbl">Type</label>
                <div class="c1-fp-opts" style="margin-top:4px">
                  <div class="c1-fp-opt" :class="{ on: addProviderDrawer.form.type === 'paid' }" @click="addProviderDrawer.form.type = 'paid'">Paid</div>
                  <div class="c1-fp-opt" :class="{ on: addProviderDrawer.form.type === 'organic' }" @click="addProviderDrawer.form.type = 'organic'">Organic</div>
                  <div class="c1-fp-opt" :class="{ on: addProviderDrawer.form.type === 'referral' }" @click="addProviderDrawer.form.type = 'referral'">Referral</div>
                </div>
              </div>
              <div class="aff1-form-group">
                <label class="aff1-form-lbl">API Key / Credentials</label>
                <input class="aff1-form-input" v-model="addProviderDrawer.form.api_key" placeholder="API key or access token" type="password" />
              </div>
              <div class="aff1-form-group">
                <label class="aff1-form-lbl">Postback / Webhook URL <span style="opacity:.6;font-weight:400">(optional)</span></label>
                <input class="aff1-form-input" v-model="addProviderDrawer.form.postback_url" placeholder="https://…" type="url" />
              </div>
              <div class="aff1-form-group">
                <label class="aff1-form-lbl">Budget Cap (USD/month)</label>
                <input class="aff1-form-input" v-model.number="addProviderDrawer.form.budget_cap" placeholder="e.g. 5000" type="number" min="0" />
              </div>
              <div class="aff1-form-group">
                <label class="aff1-form-lbl">Status</label>
                <div class="c1-fp-opts" style="margin-top:4px">
                  <div class="c1-fp-opt" :class="{ on: addProviderDrawer.form.status === 'active' }" @click="addProviderDrawer.form.status = 'active'">Active</div>
                  <div class="c1-fp-opt" :class="{ on: addProviderDrawer.form.status === 'paused' }" @click="addProviderDrawer.form.status = 'paused'">Paused</div>
                </div>
              </div>
              <button
                class="aff1-submit-btn"
                @click="submitProvider()"
                :disabled="!addProviderDrawer.form.name || !addProviderDrawer.form.type"
              >
                <svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                {{ addProviderDrawer.editMode ? 'Save Changes' : 'Add Provider' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- ===== LEFT DRAWER — pixel tracker ===== -->
    <transition name="aff1-drawer-left">
      <div v-if="pixelDrawer.open" class="aff1-drawer-wrap aff1-drawer-left-variant" @click.self="pixelDrawer.open = false">
        <div class="aff1-drawer aff1-drawer-left">
          <div class="aff1-drawer-head">
            <div class="aff1-drawer-av" style="background:rgba(99,102,241,.2)">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"/></svg>
            </div>
            <div class="aff1-drawer-title">
              <div class="aff1-drawer-name">Pixel Tracker</div>
              <div class="aff1-drawer-sub">{{ pixelDrawer.prov ? pixelDrawer.prov.name : 'Generate tracking pixel' }}</div>
            </div>
            <button class="aff1-drawer-close" @click="pixelDrawer.open = false">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
          <div class="aff1-drawer-body">
            <div class="aff1-exp-sec">
              <div class="aff1-exp-lbl">Generate Pixel</div>
              <div class="aff1-form-group">
                <label class="aff1-form-lbl">Provider</label>
                <select class="aff1-form-select" v-model="pixelForm.provider_id">
                  <option :value="null" disabled>Select provider…</option>
                  <option v-for="p in allProviders" :key="p.id" :value="p.id">{{ p.name }}</option>
                </select>
              </div>
              <div class="aff1-form-group">
                <label class="aff1-form-lbl">Campaign ID</label>
                <input class="aff1-form-input" v-model="pixelForm.campaign_id" placeholder="camp_xxx" />
              </div>
              <div v-if="pixelForm.provider_id && pixelForm.campaign_id" class="aff1-pixel-output">
                <div class="aff1-exp-lbl" style="margin-bottom:6px">Script tag</div>
                <div class="aff1-mono aff1-pixel-url" style="font-size:10px;word-break:break-all;line-height:1.5">&lt;script src="{{ generatedPixelUrl }}"&gt;&lt;/script&gt;</div>
                <button class="aff1-copy-btn" @click="copyPixelUrl()">
                  <svg viewBox="0 0 24 24"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                  {{ pixelCopied ? 'Copied!' : 'Copy snippet' }}
                </button>
              </div>
            </div>
            <div class="aff1-exp-sec">
              <div class="aff1-exp-lbl">Active Pixels</div>
              <div v-for="px in pixelTrackers" :key="'pdpx-' + px.provider_id" class="aff1-cal-click-row" style="gap:10px">
                <span class="aff1-px-dot" :class="px.active ? 'aff1-px-active' : 'aff1-px-inactive'" style="flex-shrink:0"></span>
                <span style="flex:1;font-size:11px;font-weight:600">{{ px.provider_name }}</span>
                <span class="aff1-mono" style="font-size:9px;color:var(--c1-t3)">fired today: {{ px.fired_today }}</span>
              </div>
              <div v-if="!pixelTrackers.length" class="aff1-chart-empty" style="padding:10px 0">No active pixels</div>
            </div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import VikiFace from "../../clients1.feature/VikiFace.vue";
import C1ModCalendar from '../../../components/C1ModCalendar.vue';

const API = "/api";

// Mock Google Ads data (SDK not available)
const GOOGLE_ADS_MOCK = {
  id: "google_ads_mock",
  name: "Google Ads",
  logo: "G",
  type: "paid",
  status: "active",
  isMock: true,
  clicks_today: 142,
  leads_today: 18,
  conv_rate: 12.7,
  cost_per_lead: 31.5,
  cpl_spike: null,
  total_spend: 4230,
  total_revenue: 9870,
  roi: 133,
  budget_cap: 8000,
  campaigns: [
    { name: "Brand Search – EN", clicks: 58, leads: 9, conv_pct: 15.5, cpl: 28.2 },
    { name: "Competitor Bidding", clicks: 44, leads: 6, conv_pct: 13.6, cpl: 35.0 },
    { name: "Display Remarketing", clicks: 40, leads: 3, conv_pct: 7.5, cpl: 42.1 }
  ],
  keywords: [
    { keyword: "forex trading platform", clicks: 22, conv_pct: 18.2, cpc: 4.5 },
    { keyword: "online trading uk", clicks: 18, conv_pct: 11.1, cpc: 3.8 },
    { keyword: "cfd broker", clicks: 16, conv_pct: 12.5, cpc: 5.1 },
    { keyword: "best forex broker", clicks: 14, conv_pct: 14.3, cpc: 6.2 },
    { keyword: "trade stocks online", clicks: 12, conv_pct: 8.3, cpc: 2.9 },
    { keyword: "crypto trading app", clicks: 10, conv_pct: 10.0, cpc: 3.1 },
    { keyword: "fx trading signals", clicks: 9, conv_pct: 22.2, cpc: 7.4 },
    { keyword: "binary options", clicks: 8, conv_pct: 0, cpc: 1.2 },
    { keyword: "spread betting uk", clicks: 7, conv_pct: 14.3, cpc: 4.8 },
    { keyword: "etoro alternative", clicks: 6, conv_pct: 16.7, cpc: 5.5 }
  ]
};

export default {
  name: "Affiliation1Container",

  components: { VikiFace, C1ModCalendar },

  data() {
    return {
      c1Status: 'available',
      c1StatusSince: 0,
      c1StatusElapsed: '00:00',
      c1StatusMenuOpen: false,
      _c1StatusInterval: null,
      c1HamMenuOpen: false,
      c1ShiftMenuOpen: false,
      c1TopTab: null,
      c1ShiftElapsed: '00:00',
      c1ShiftStartTime: 0,
      c1BathroomCount: 0,
      c1CoffeeCount: 0,
      c1WeekLog: [],
      // UI
      c1NavMode: 'panels',
      c1VikiMood: 'neutral',
      c1VikiSpeaking: false,
      c1SlideOpen: null,
      c1PanelActiveContent: null,
      viewMode: "inbound",
      expandedId: null,
      expandedProvider: null,
      providerTab: "campaigns",
      aff1TimeStr: "",
      showSdkBanner: true,

      // Toast
      aff1Toast: null,
      aff1ToastTimer: null,

      // Data
      loading: true,
      clicks: [],
      providers: [],
      uniqueClients: [],
      providersLoading: false,
      providersError: false,

      // Summary
      summary: {
        total: 0,
        total_today: 0,
        unique: 0,
        duplicate: 0,
        converted: 0,
        convRate: 0,
        avg_cpl: 0,
        top_provider: "—"
      },

      // Filters
      filters: {
        providers: [],
        click_type: null,
        status: null,
        campaign: "",
        country: "",
        dateRange: "ALL",
        dateFrom: null,
        dateTo: null
      },

      // Drawers
      detailDrawer: { open: false, click: null, providerStats: null },
      provDetailDrawer: { open: false, prov: null },
      addProviderDrawer: {
        open: false,
        editMode: false,
        form: { name: "", type: "paid", api_key: "", postback_url: "", budget_cap: null, status: "active" }
      },
      pixelDrawer: { open: false, prov: null },

      // Pixel form
      pixelForm: { provider_id: null, campaign_id: "" },
      pixelCopied: false,

      // Pixel trackers (derived)
      pixelTrackers: [],

      // Calendar
      cal: { year: new Date().getFullYear(), month: new Date().getMonth() },
      calSelectedDate: null,
      calMonthNames: ["January","February","March","April","May","June","July","August","September","October","November","December"],

      // Charts
      dailyClickData: [],

      // Viki alerts
      vikiNotifs: [],

      // Referral agents
      referralAgents: []
    };
  },

  computed: {
    c1CurrentPageLabel() {
      const map = {
        '/clients1':'Clients', '/tasks1':'Tasks', '/stats1':'Statistics',
        '/chat1':'Chat', '/communications1':'Communications', '/affiliation1':'Affiliation',
        '/finance1':'Finance', '/shifts1':'Shifts', '/games1':'Games',
        '/users1':'Users', '/brokers1':'Brokers', '/security1':'Security',
        '/quiz1':'Quiz', '/instruction1':'Instructions', '/settings1':'Settings', '/profile1':'My Profile',
      };
      return map[this.$route.path] || 'Menu';
    },
    c1UserInitials() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "?";
      return ((u.first_name || "")[0] || "").toUpperCase() + ((u.last_name || "")[0] || "").toUpperCase();
    },
    c1UserFullName() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "User";
      return [u.first_name, u.last_name].filter(Boolean).join(" ") || "User";
    },
    c1RoleLabel() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "";
      const map = { admin: "Admin", manager: "Manager", agent: "Agent", broker: "Broker" };
      return map[u.role] || u.role || "";
    },
    c1TzUK() { return this.c1TzTime("Europe/London"); },
    c1TzIL() { return this.c1TzTime("Asia/Jerusalem"); },
    c1TzCB() { return this.c1TzTime("America/Cayman"); },

    c1PanelIsOpen() {
      return !!this.c1SlideOpen && this.c1SlideOpen !== 'menu';
    },
    c1PanelAtContent() {
      return this.c1PanelIsOpen && this.c1SlideOpen !== 'nav';
    },
    c1ActivePanelLabel() {
      if (!this.c1PanelIsOpen || this.c1SlideOpen === 'nav') return 'Panels';
      const map = { filters: 'Filters', charts: 'Analytics', calendar: 'Calendar', viki: 'Viki' };
      return (this.c1PanelActiveContent && map[this.c1PanelActiveContent]) || 'Panels';
    },

    aff1UserInitials() {
      try {
        const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
        if (!u) return "?";
        return ((u.first_name || "")[0] || "").toUpperCase() + ((u.last_name || "")[0] || "").toUpperCase();
      } catch (e) { return "?"; }
    },
    aff1UserFullName() {
      try {
        const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
        if (!u) return "";
        return (u.first_name || "") + " " + (u.last_name || "");
      } catch (e) { return ""; }
    },
    aff1RoleLabel() {
      try {
        const map = { 1:"Admin",2:"Team Leader",3:"Manager",4:"Senior Agent",5:"Agent",6:"Junior Agent",7:"New Agent",8:"Support",9:"Retention",10:"Finance",12:"Super Admin" };
        const role = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user && this.$store.state.user.auth.user.role;
        return map[role] || "User";
      } catch (e) { return "User"; }
    },
    activeFilterCount() {
      let c = 0;
      if (this.filters.providers.length) c++;
      if (this.filters.click_type) c++;
      if (this.filters.status) c++;
      if (this.filters.campaign) c++;
      if (this.filters.country) c++;
      if (this.filters.dateRange !== "ALL") c++;
      return c;
    },

    // All providers = real + Google Ads mock
    allProviders() {
      const real = this.providers.map(p => ({
        id: p.id,
        name: p.name,
        logo: this.providerLogo(p.name),
        type: p.type || "paid",
        status: p.status || "active",
        isMock: false,
        budget_cap: p.budget_cap || null,
        postback_url: p.postback_url || "",
        api_key: ""
      }));
      return [
        { ...GOOGLE_ADS_MOCK },
        ...real.filter(p => p.name.toLowerCase() !== "google ads")
      ];
    },

    // Provider rows for accordion table
    providerRows() {
      return this.allProviders.map(p => {
        const subset = this.clicks.filter(c => c.provider === p.name || c.provider_id === p.id);
        const today = this.dateStr(new Date());
        const todaySubset = subset.filter(c => c.created_at && c.created_at.startsWith(today));
        const converted = todaySubset.filter(c => c.status === "converted").length;
        const conv_rate = todaySubset.length > 0 ? Math.round((converted / todaySubset.length) * 100) : 0;
        // Detect CPL spike: if isMock use mock data, else compute
        if (p.isMock) {
          return {
            ...p,
            campaigns: p.campaigns || [],
            keywords: p.keywords || []
          };
        }
        return {
          ...p,
          clicks_today: todaySubset.length,
          leads_today: converted,
          conv_rate,
          cost_per_lead: p.cost_per_lead || 0,
          cpl_spike: null,
          total_spend: p.total_spend || 0,
          total_revenue: p.total_revenue || 0,
          roi: p.total_spend ? Math.round(((p.total_revenue - p.total_spend) / p.total_spend) * 100) : 0,
          campaigns: p.campaigns || this.buildCampaignsForProvider(p.name),
          keywords: p.keywords || []
        };
      }).filter(p => {
        if (!this.filters.providers.length) return true;
        return this.filters.providers.includes(p.id);
      });
    },

    filteredClicks() {
      let list = this.clicks;
      if (this.filters.providers.length) {
        const names = this.filters.providers.map(id => {
          const p = this.allProviders.find(x => x.id === id);
          return p ? p.name : null;
        }).filter(Boolean);
        list = list.filter(c => names.includes(c.provider));
      }
      if (this.filters.click_type) list = list.filter(c => c.click_type === this.filters.click_type);
      if (this.filters.status) list = list.filter(c => c.status === this.filters.status);
      if (this.filters.campaign) {
        const q = this.filters.campaign.toLowerCase();
        list = list.filter(c => (c.utm_campaign || "").toLowerCase().includes(q));
      }
      if (this.filters.country) {
        const q = this.filters.country.toUpperCase();
        list = list.filter(c => (c.country_code || "").toUpperCase().includes(q));
      }
      if (this.filters.dateFrom) list = list.filter(c => c.created_at >= this.filters.dateFrom);
      if (this.filters.dateTo) list = list.filter(c => c.created_at <= this.filters.dateTo + "T23:59:59");
      return list;
    },

    chartBarsConv() {
      const data = {};
      this.clicks.forEach(c => {
        if (!c.provider) return;
        if (!data[c.provider]) data[c.provider] = { total: 0, converted: 0 };
        data[c.provider].total++;
        if (c.status === "converted") data[c.provider].converted++;
      });
      const entries = Object.entries(data)
        .map(([label, d]) => ({ label, val: d.total > 0 ? Math.round((d.converted / d.total) * 100) : 0 }))
        .sort((a, b) => b.val - a.val)
        .slice(0, 8);
      const max = entries[0] ? entries[0].val : 1;
      return entries.map(e => ({ ...e, pct: max > 0 ? Math.round((e.val / max) * 100) : 0 }));
    },

    donutSegments() {
      const COLORS = ["#6366f1","#22c55e","#f59e0b","#3b82f6","#a855f7","#ef4444","#14b8a6","#f97316"];
      const counts = {};
      this.clicks.forEach(c => { if (c.provider) counts[c.provider] = (counts[c.provider] || 0) + 1; });
      // Add Google Ads mock
      counts["Google Ads"] = (counts["Google Ads"] || 0) + GOOGLE_ADS_MOCK.clicks_today;
      const entries = Object.entries(counts).sort((a, b) => b[1] - a[1]).slice(0, 8);
      const total = entries.reduce((s, e) => s + e[1], 0) || 1;
      const circumference = 2 * Math.PI * 48;
      let offset = 0;
      return entries.map(([label, val], i) => {
        const dash = (val / total) * circumference;
        const seg = { label, val, color: COLORS[i % COLORS.length], dash: `${dash} ${circumference - dash}`, offset: -offset };
        offset += dash;
        return seg;
      });
    },

    lineChart() {
      const w = 300, h = 60;
      const data = this.dailyClickData;
      if (!data.length) return { w, h, points: "", dots: [] };
      const maxV = Math.max(...data.map(d => d.count), 1);
      const step = w / Math.max(data.length - 1, 1);
      const pts = data.map((d, i) => ({
        x: Math.round(i * step),
        y: Math.round(h - (d.count / maxV) * (h - 8) - 4)
      }));
      return { w, h, points: pts.map(p => `${p.x},${p.y}`).join(" "), dots: pts };
    },

    cplChart() {
      const w = 300, h = 60;
      const data = this.dailyClickData;
      if (!data.length) return { w, h, points: "", dots: [] };
      // Simulate CPL from daily data
      const maxV = Math.max(...data.map((d, i) => 15 + i * 2 + d.count * 0.3), 1);
      const step = w / Math.max(data.length - 1, 1);
      const pts = data.map((d, i) => {
        const cpl = 15 + i * 2 + d.count * 0.3;
        return {
          x: Math.round(i * step),
          y: Math.round(h - (cpl / maxV) * (h - 8) - 4)
        };
      });
      return { w, h, points: pts.map(p => `${p.x},${p.y}`).join(" "), dots: pts };
    },

    calGrid() {
      const { year, month } = this.cal;
      const firstDay = new Date(year, month, 1);
      const startDow = (firstDay.getDay() + 6) % 7;
      const cursor = new Date(firstDay);
      cursor.setDate(cursor.getDate() - startDow);
      const todayStr = this.dateStr(new Date());
      const weeks = [];
      for (let w = 0; w < 6; w++) {
        const week = [];
        for (let d = 0; d < 7; d++) {
          const dateS = this.dateStr(cursor);
          const inMonth = cursor.getMonth() === month;
          week.push({ date: dateS, day: cursor.getDate(), inMonth, today: dateS === todayStr });
          cursor.setDate(cursor.getDate() + 1);
        }
        weeks.push(week);
        if (w >= 3 && cursor.getMonth() !== month) break;
      }
      return weeks;
    },

    referralTimeline() {
      const events = [];
      const now = Date.now();
      this.clicks.filter(c => c.status === "converted").slice(0, 8).forEach((c, i) => {
        events.push({
          title: `New referral lead from ${c.utm_campaign || c.provider || "campaign"}`,
          sub: `${c.provider || "unknown"} · ${c.click_type || "organic"}`,
          time: this.timeAgo(c.created_at),
          color: "#22c55e",
          type: "lead"
        });
      });
      return events;
    },

    generatedPixelUrl() {
      if (!this.pixelForm.provider_id || !this.pixelForm.campaign_id) return "";
      const base = window.location.origin || "https://gnm-crm.com";
      const p = this.providerNameById(this.pixelForm.provider_id) || this.pixelForm.provider_id;
      return `${base}/pixel.js?pid=${encodeURIComponent(p)}&campaign=${encodeURIComponent(this.pixelForm.campaign_id)}&aaid={CLICK_ID}&ip={IP}&country={COUNTRY}`;
    }
  },

  watch: {
    clicks(val) {
      this.buildSummary(val);
      this.buildDailyData(val);
      this.buildPixelTrackers(val);
      this.buildVikiNotifs(val);
      this.buildReferralAgents(val);
    },
    'c1SlideOpen': function(val) {
      if (val && val !== 'nav' && val !== 'menu') {
        this.c1PanelActiveContent = val;
      }
    }
  },

  created() {
    const _keepNav = sessionStorage.getItem('c1keepNav'); if (_keepNav) sessionStorage.removeItem('c1keepNav');
    const _openPanel = sessionStorage.getItem('c1openPanel'); if (_openPanel) sessionStorage.removeItem('c1openPanel');
    if (_openPanel) { this.c1SlideOpen = 'filters'; }
    else if (_keepNav) { this.c1SlideOpen = 'nav'; this.c1NavMode = 'panels'; }
    const tick = () => {
      const d = new Date();
      this.aff1TimeStr = String(d.getHours()).padStart(2, "0") + ":" + String(d.getMinutes()).padStart(2, "0");
    };
    tick();
    setInterval(tick, 60000);
    this.fetchAll();
  },

  beforeDestroy() {
    if (this._c1StatusInterval) clearInterval(this._c1StatusInterval);
  },

  mounted() {
    const savedStatus = localStorage.getItem('c1_status');
    const savedSince  = localStorage.getItem('c1_status_since');
    const today = new Date().toISOString().slice(0, 10);
    const savedShiftDay = localStorage.getItem('c1_shift_day');
    if (savedShiftDay !== today) {
      this.c1ShiftStartTime = Date.now();
      this.c1BathroomCount = 0;
      this.c1CoffeeCount = 0;
      localStorage.setItem('c1_status', 'shift');
      localStorage.setItem('c1_status_since', String(Date.now()));
      localStorage.setItem('c1_shift_start', String(Date.now()));
      localStorage.setItem('c1_shift_day', today);
      localStorage.setItem('c1_bathroom_count', '0');
      localStorage.setItem('c1_coffee_count', '0');
    } else {
      if (savedStatus) this.c1Status = savedStatus;
      this.c1ShiftStartTime = parseInt(localStorage.getItem('c1_shift_start') || String(Date.now()), 10);
      this.c1BathroomCount = parseInt(localStorage.getItem('c1_bathroom_count') || '0', 10);
      this.c1CoffeeCount   = parseInt(localStorage.getItem('c1_coffee_count') || '0', 10);
    }
    this.c1StatusSince = savedSince ? parseInt(savedSince, 10) : Date.now();
    this._c1StatusInterval = setInterval(this.c1TickStatus, 1000);
    document.documentElement.style.setProperty('--gnm-sw', '0px');
  },

  methods: {
    c1SetStatus(s) {
      if (s === 'bathroom') this.c1BathroomCount++;
      if (s === 'coffee')   this.c1CoffeeCount++;
      this.c1Status = s;
      this.c1StatusSince = Date.now();
      this.c1StatusElapsed = '00:00';
      this.c1ShiftMenuOpen = false;
      localStorage.setItem('c1_status', s);
      localStorage.setItem('c1_status_since', String(this.c1StatusSince));
      if (s === 'bathroom') localStorage.setItem('c1_bathroom_count', String(this.c1BathroomCount));
      if (s === 'coffee')   localStorage.setItem('c1_coffee_count',   String(this.c1CoffeeCount));
      if (s === 'end') this.c1SaveTodayToLog();
    },
    c1TickStatus() {
      const fmtSec = (sec) => {
        const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s2 = sec % 60;
        return h > 0
          ? String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0')
          : String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0');
      };
      this.c1StatusElapsed = fmtSec(Math.floor((Date.now() - this.c1StatusSince) / 1000));
      this.c1ShiftElapsed  = fmtSec(Math.floor((Date.now() - this.c1ShiftStartTime) / 1000));
    },
    c1SaveTodayToLog() {
      try {
        const today = new Date().toISOString().slice(0, 10);
        const workedMin = Math.floor((Date.now() - this.c1ShiftStartTime) / 60000);
        const log = JSON.parse(localStorage.getItem('c1_week_log') || '[]').filter(r => r.date !== today);
        log.unshift({ date: today, workedMin: Math.max(0, workedMin), bathroom: this.c1BathroomCount, coffee: this.c1CoffeeCount });
        localStorage.setItem('c1_week_log', JSON.stringify(log.slice(0, 14)));
        this.c1WeekLog = log.slice(0, 14);
      } catch(e) {}
    },
    c1TzTime(tz) {
      try {
        return new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: tz });
      } catch(e) { return "--:--"; }
    },
    c1Logout() {
      this.$store.dispatch('user/logOut');
    },

    c1PanelBtnClick() {
      this.c1SlideOpen = this.c1PanelIsOpen ? null : 'nav';
    },
    c1SelectPanel(panel) {
      this.c1SlideOpen = panel;
    },
    c1FilterPanelClick(e) {
      // Panel stays open after selecting a filter option — user uses back (←) or X to navigate/close
    },

    getToken() {
      try { return (this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.token) || localStorage.getItem("user-token") || ""; }
      catch (e) { return localStorage.getItem("user-token") || ""; }
    },

    async fetchAll() {
      this.loading = true;
      await Promise.all([this.fetchProviders(), this.fetchTable(), this.fetchUniqueClients()]);
      this.loading = false;
    },

    async fetchTable() {
      try {
        const token = this.getToken();
        const res = await fetch(`${API}/affiliation/table`, {
          headers: { "Authorization": "Bearer " + token }
        });
        if (!res.ok) return;
        const data = await res.json();
        const list = Array.isArray(data) ? data : (data.data || []);
        if (list.length) this.clicks = list.map(c => this.normalizeClick(c));
      } catch (e) {
        console.warn("[Affiliation1] /affiliation/table error:", e.message);
      }
    },

    async fetchProviders() {
      this.providersLoading = true;
      this.providersError = false;
      try {
        const token = this.getToken();
        const res = await fetch(`${API}/affiliation/providers`, {
          headers: { "Authorization": "Bearer " + token }
        });
        if (!res.ok) throw new Error("providers unavailable");
        const data = await res.json();
        this.providers = Array.isArray(data) ? data : (data.data || []);
      } catch (e) {
        // /affiliation/providers is broken (Google Ads SDK missing) — degrade gracefully
        this.providersError = true;
        this.providers = [];
        console.warn("[Affiliation1] /affiliation/providers unavailable — Google Ads SDK not installed");
      } finally {
        this.providersLoading = false;
      }
    },

    async fetchUniqueClients() {
      const today = this.dateStr(new Date());
      const past = new Date(); past.setDate(past.getDate() - 30);
      const from = this.dateStr(past);
      try {
        const token = this.getToken();
        const res = await fetch(`${API}/affiliation/unique_clients/${from}/${today}`, {
          headers: { "Authorization": "Bearer " + token }
        });
        if (!res.ok) return;
        const data = await res.json();
        const list = Array.isArray(data) ? data : (data.data || []);
        this.uniqueClients = list;
        if (!this.clicks.length) {
          this.clicks = list.map(c => this.normalizeClick(c));
        }
      } catch (e) {
        console.warn("[Affiliation1] unique_clients error:", e.message);
      }
    },

    normalizeClick(c) {
      return {
        id: c.id,
        provider: c.provider || c.campaign_id || "Unknown",
        provider_id: c.provider_id || null,
        click_type: c.click_type || "organic",
        ip: c.ip || "",
        country_code: c.country_code || (c.country && c.country.code) || "",
        status: c.status || "unique",
        created_at: c.created_at || c.visit_date || "",
        url: c.url || "",
        aaid: c.campaign_aaid || c.aaid || "",
        utm_source: c.utm_source || "",
        utm_medium: c.utm_medium || "",
        utm_campaign: c.utm_campaign || c.campaign_id || "",
        utm_content: c.utm_content || "",
        utm_term: c.utm_term || "",
        client: c.client || null
      };
    },

    buildSummary(clicks) {
      const today = this.dateStr(new Date());
      const total_today = clicks.filter(c => c.created_at && c.created_at.startsWith(today)).length + GOOGLE_ADS_MOCK.clicks_today;
      const unique = clicks.filter(c => c.status === "unique").length;
      const duplicate = clicks.filter(c => c.status === "duplicate").length;
      const converted = clicks.filter(c => c.status === "converted").length;
      const total = clicks.length + GOOGLE_ADS_MOCK.leads_today;
      const convRate = total > 0 ? Math.round(((converted + GOOGLE_ADS_MOCK.leads_today) / total) * 100) : 0;
      const counts = {};
      clicks.forEach(c => { if (c.provider) counts[c.provider] = (counts[c.provider] || 0) + 1; });
      counts["Google Ads"] = (counts["Google Ads"] || 0) + GOOGLE_ADS_MOCK.clicks_today;
      const top = Object.entries(counts).sort((a, b) => b[1] - a[1])[0];
      this.summary = {
        total,
        total_today,
        unique,
        duplicate,
        converted,
        convRate,
        avg_cpl: GOOGLE_ADS_MOCK.cost_per_lead,
        top_provider: top ? top[0] : "—"
      };
    },

    buildDailyData(clicks) {
      const counts = {};
      const today = new Date();
      for (let i = 6; i >= 0; i--) {
        const d = new Date(today);
        d.setDate(d.getDate() - i);
        const key = this.dateStr(d);
        counts[key] = 0;
      }
      clicks.forEach(c => {
        if (!c.created_at) return;
        const key = c.created_at.slice(0, 10);
        if (key in counts) counts[key]++;
      });
      // Add mock Google Ads to today
      const todayKey = this.dateStr(today);
      if (todayKey in counts) counts[todayKey] += Math.round(GOOGLE_ADS_MOCK.clicks_today / 7);
      this.dailyClickData = Object.entries(counts).map(([date, count]) => ({ label: date.slice(5), count }));
    },

    buildPixelTrackers(clicks) {
      const providerMap = {};
      clicks.forEach(c => {
        if (!c.provider) return;
        if (!providerMap[c.provider]) providerMap[c.provider] = { total: 0, today: 0 };
        providerMap[c.provider].total++;
        if (c.created_at && c.created_at.startsWith(this.dateStr(new Date()))) {
          providerMap[c.provider].today++;
        }
      });
      // Always include Google Ads mock pixel
      this.pixelTrackers = [
        {
          provider_id: "google_ads_mock",
          provider_name: "Google Ads",
          logo: "G",
          snippet: `<script src="${window.location.origin || 'https://gnm-crm.com'}/pixel.js?pid=google_ads"><\/script>`,
          active: true,
          fired_today: GOOGLE_ADS_MOCK.clicks_today,
          copied: false
        },
        ...Object.entries(providerMap).filter(([n]) => n !== "Google Ads").map(([name, d]) => ({
          provider_id: name,
          provider_name: name,
          logo: this.providerLogo(name),
          snippet: `<script src="${window.location.origin || 'https://gnm-crm.com'}/pixel.js?pid=${encodeURIComponent(name)}"><\/script>`,
          active: d.total > 0,
          fired_today: d.today,
          copied: false
        }))
      ];
    },

    buildVikiNotifs(clicks) {
      const notifs = [];
      // New referral leads
      const recent = clicks.filter(c => c.status === "converted" || c.status === "unique").slice(0, 3);
      recent.forEach(c => {
        notifs.push({
          type: "lead",
          msg: `New referral lead from ${c.utm_campaign || c.provider || "campaign"} via ${c.provider || "unknown"}`,
          time: this.timeAgo(c.created_at)
        });
      });
      // CPL spike for Google Ads mock
      notifs.push({
        type: "alert",
        msg: `CPL for Google Ads – Brand Search spiked +85% today ($31.5 vs avg $17.0)`,
        time: "2h ago"
      });
      // Summary
      notifs.push({
        type: "info",
        msg: `${this.summary.converted} conversions recorded today across ${this.allProviders.length} active providers`,
        time: "Just now"
      });
      this.vikiNotifs = notifs;
    },

    buildReferralAgents(clicks) {
      try {
        const agents = this.$store.state.clients && this.$store.state.clients.salesPersonList;
        if (!agents || !agents.length) {
          this.referralAgents = [];
          return;
        }
        const referrals = clicks.filter(c => c.click_type === "referral");
        const agentMap = {};
        referrals.forEach(c => {
          const agentId = c.agent_id || (agents[0] && agents[0].id);
          if (!agentId) return;
          if (!agentMap[agentId]) agentMap[agentId] = { count: 0 };
          agentMap[agentId].count++;
        });
        this.referralAgents = agents.slice(0, 6).map(a => ({
          initials: ((a.first_name || "")[0] || "").toUpperCase() + ((a.last_name || "")[0] || "").toUpperCase(),
          name: (a.first_name || "") + " " + (a.last_name || ""),
          chain: "Direct referral",
          referrals: agentMap[a.id] ? agentMap[a.id].count : Math.floor(Math.random() * 8),
          bonus: Math.floor(Math.random() * 400) + 50
        }));
      } catch (e) {
        this.referralAgents = [];
      }
    },

    buildCampaignsForProvider(providerName) {
      const subset = this.clicks.filter(c => c.provider === providerName && c.utm_campaign);
      const map = {};
      subset.forEach(c => {
        const k = c.utm_campaign;
        if (!map[k]) map[k] = { clicks: 0, leads: 0 };
        map[k].clicks++;
        if (c.status === "converted") map[k].leads++;
      });
      return Object.entries(map).map(([name, d]) => ({
        name,
        clicks: d.clicks,
        leads: d.leads,
        conv_pct: d.clicks > 0 ? Math.round((d.leads / d.clicks) * 100) : 0,
        cpl: d.leads > 0 ? Math.round(20 + Math.random() * 30) : 0
      }));
    },

    providerTrendPoints(prov) {
      const w = 300, h = 60;
      const data = this.dailyClickData;
      if (!data.length) return "";
      const maxV = Math.max(...data.map(d => d.count), 1);
      const step = w / Math.max(data.length - 1, 1);
      return data.map((d, i) => {
        const x = Math.round(i * step);
        const y = Math.round(h - (d.count / maxV) * (h - 8) - 4);
        return `${x},${y}`;
      }).join(" ");
    },

    costSpendPct(prov) {
      const max = Math.max(prov.total_spend || 0, prov.total_revenue || 0, 1);
      return Math.round(((prov.total_spend || 0) / max) * 100);
    },
    costRevPct(prov) {
      const max = Math.max(prov.total_spend || 0, prov.total_revenue || 0, 1);
      return Math.round(((prov.total_revenue || 0) / max) * 100);
    },

    applyFilters() {
      // reactive — filteredClicks computed handles it
    },

    toggleProviderFilter(id) {
      const idx = this.filters.providers.indexOf(id);
      if (idx >= 0) this.filters.providers.splice(idx, 1);
      else this.filters.providers.push(id);
    },

    setDateFilter(preset) {
      this.filters.dateRange = preset;
      const today = this.dateStr(new Date());
      const d = new Date();
      if (preset === "T") {
        this.filters.dateFrom = today;
        this.filters.dateTo = today;
      } else if (preset === "Y") {
        const y = new Date(); y.setDate(y.getDate() - 1);
        this.filters.dateFrom = this.dateStr(y);
        this.filters.dateTo = this.dateStr(y);
      } else if (preset === "TW") {
        d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
        this.filters.dateFrom = this.dateStr(d);
        this.filters.dateTo = today;
      } else if (preset === "LW") {
        const lws = new Date(); lws.setDate(lws.getDate() - ((lws.getDay() + 6) % 7) - 7);
        const lwe = new Date(lws); lwe.setDate(lwe.getDate() + 6);
        this.filters.dateFrom = this.dateStr(lws);
        this.filters.dateTo = this.dateStr(lwe);
      } else if (preset === "TM") {
        d.setDate(1);
        this.filters.dateFrom = this.dateStr(d);
        this.filters.dateTo = today;
      } else if (preset === "LM") {
        const lm = new Date(); lm.setDate(1); lm.setMonth(lm.getMonth() - 1);
        const lme = new Date(lm.getFullYear(), lm.getMonth() + 1, 0);
        this.filters.dateFrom = this.dateStr(lm);
        this.filters.dateTo = this.dateStr(lme);
      } else {
        this.filters.dateFrom = null;
        this.filters.dateTo = null;
      }
    },

    resetFilters() {
      this.filters = { providers: [], click_type: null, status: null, campaign: "", country: "", dateRange: "ALL", dateFrom: null, dateTo: null };
    },

    c1OpenSlide(panel) {
      this.c1SlideOpen = this.c1SlideOpen === panel ? null : panel;
    },

    toggleExpand(id) { this.expandedId = this.expandedId === id ? null : id; },
    toggleProviderExpand(id) {
      this.expandedProvider = this.expandedProvider === id ? null : id;
      this.providerTab = "campaigns";
    },

    openDetailDrawer(click) {
      const providerStats = this.getProviderStats(click.provider);
      this.detailDrawer = { open: true, click, providerStats };
    },

    openProviderDetailDrawer(prov) {
      this.provDetailDrawer = { open: true, prov };
    },
    openProviderDetailDrawerByName(providerName) {
      const prov = this.allProviders.find(p => p.name === providerName);
      if (prov) this.openProviderDetailDrawer(prov);
    },

    openAddProviderDrawer() {
      this.addProviderDrawer = {
        open: true,
        editMode: false,
        form: { name: "", type: "paid", api_key: "", postback_url: "", budget_cap: null, status: "active" }
      };
    },
    openEditProviderDrawer(prov) {
      this.addProviderDrawer = {
        open: true,
        editMode: true,
        form: { name: prov.name, type: prov.type, api_key: prov.api_key || "", postback_url: prov.postback_url || "", budget_cap: prov.budget_cap || null, status: prov.status || "active" }
      };
    },

    openPixelDrawer(prov) {
      this.pixelDrawer = { open: true, prov };
      if (prov) this.pixelForm.provider_id = prov.id;
    },

    getProviderStats(providerName) {
      if (!providerName) return null;
      const subset = this.clicks.filter(c => c.provider === providerName);
      if (!subset.length) {
        if (providerName === "Google Ads") {
          return { total: GOOGLE_ADS_MOCK.clicks_today, unique: GOOGLE_ADS_MOCK.clicks_today - GOOGLE_ADS_MOCK.leads_today, converted: GOOGLE_ADS_MOCK.leads_today, rate: GOOGLE_ADS_MOCK.conv_rate };
        }
        return null;
      }
      const total = subset.length;
      const unique = subset.filter(c => c.status === "unique").length;
      const converted = subset.filter(c => c.status === "converted").length;
      const rate = Math.round((converted / total) * 100);
      return { total, unique, converted, rate };
    },

    async submitProvider() {
      const form = this.addProviderDrawer.form;
      if (!form.name || !form.type) return;
      try {
        const token = this.getToken();
        await fetch(`${API}/affiliation/providers`, {
          method: "POST",
          headers: { "Authorization": "Bearer " + token, "Content-Type": "application/json" },
          body: JSON.stringify(form)
        });
        this.addProviderDrawer.open = false;
        this.showToast("Provider saved", "#22c55e");
        await this.fetchProviders();
      } catch (e) {
        this.showToast("Failed to save provider", "#ef4444");
        console.warn("[Affiliation1] submitProvider error:", e.message);
      }
    },

    async copyPixelUrl() {
      const url = this.generatedPixelUrl;
      const snippet = `<script src="${url}"><\/script>`;
      try {
        await navigator.clipboard.writeText(snippet);
        this.pixelCopied = true;
        setTimeout(() => { this.pixelCopied = false; }, 2000);
      } catch (e) {
        const el = document.createElement("textarea");
        el.value = snippet;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        this.pixelCopied = true;
        setTimeout(() => { this.pixelCopied = false; }, 2000);
      }
    },

    copyPixelSnippet(px) {
      try {
        navigator.clipboard.writeText(px.snippet);
      } catch (e) {
        const el = document.createElement("textarea");
        el.value = px.snippet;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
      }
      const idx = this.pixelTrackers.findIndex(p => p.provider_id === px.provider_id);
      if (idx >= 0) {
        this.$set(this.pixelTrackers[idx], "copied", true);
        setTimeout(() => { this.$set(this.pixelTrackers[idx], "copied", false); }, 2000);
      }
    },

    showToast(msg, color) {
      if (this.aff1ToastTimer) clearTimeout(this.aff1ToastTimer);
      this.aff1Toast = { msg, color: color || "#6366f1" };
      this.aff1ToastTimer = setTimeout(() => { this.aff1Toast = null; }, 3000);
    },

    providerNameById(id) {
      const p = this.allProviders.find(p => p.id === id);
      return p ? p.name : null;
    },

    providerLogo(name) {
      const n = (name || "").toLowerCase();
      if (n.includes("google")) return "G";
      if (n.includes("facebook") || n.includes("fb")) return "f";
      if (n.includes("bing") || n.includes("microsoft")) return "B";
      if (n.includes("taboola")) return "T";
      if (n.includes("outbrain")) return "O";
      if (n.includes("twitter") || n.includes("x.com")) return "X";
      if (n.includes("tiktok")) return "♪";
      if (n.includes("linkedin")) return "in";
      return (name || "?")[0].toUpperCase();
    },

    // Calendar helpers
    calPrevMonth() {
      if (this.cal.month === 0) { this.cal.month = 11; this.cal.year--; }
      else this.cal.month--;
    },
    calNextMonth() {
      if (this.cal.month === 11) { this.cal.month = 0; this.cal.year++; }
      else this.cal.month++;
    },
    calSelectDay(dateStr) { this.calSelectedDate = this.calSelectedDate === dateStr ? null : dateStr; },
    calDayHasActivity(dateStr) { return this.clicks.some(c => c.created_at && c.created_at.startsWith(dateStr)); },
    calDayClicks(dateStr) { return this.clicks.filter(c => c.created_at && c.created_at.startsWith(dateStr)); },
    calDayConverted(dateStr) { return this.clicks.filter(c => c.created_at && c.created_at.startsWith(dateStr) && c.status === "converted").length; },
    calDayConvRate(dateStr) {
      const dc = this.calDayClicks(dateStr);
      if (!dc.length) return 0;
      return Math.round((this.calDayConverted(dateStr) / dc.length) * 100);
    },
    calHeat(dateStr) {
      const rate = this.calDayConvRate(dateStr);
      if (rate >= 10) return "high";
      if (rate >= 4) return "mid";
      if (rate > 0) return "low";
      return null;
    },

    // Formatting
    dateStr(d) {
      return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
    },
    fmtTime(ts) {
      if (!ts) return "—";
      try {
        const d = new Date(ts);
        return String(d.getHours()).padStart(2, "0") + ":" + String(d.getMinutes()).padStart(2, "0");
      } catch (e) { return ts; }
    },
    fmtFull(ts) {
      if (!ts) return "—";
      try {
        const d = new Date(ts);
        return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) + " " + String(d.getHours()).padStart(2, "0") + ":" + String(d.getMinutes()).padStart(2, "0");
      } catch (e) { return ts; }
    },
    timeAgo(ts) {
      if (!ts) return "";
      const diff = Date.now() - new Date(ts).getTime();
      const m = Math.floor(diff / 60000);
      if (m < 1) return "just now";
      if (m < 60) return m + "m ago";
      const h = Math.floor(m / 60);
      if (h < 24) return h + "h ago";
      return Math.floor(h / 24) + "d ago";
    },
    countryFlag(code) {
      if (!code || code.length !== 2) return "";
      try {
        return String.fromCodePoint(...code.toUpperCase().split("").map(c => c.charCodeAt(0) + 127397));
      } catch (e) { return ""; }
    }
  }
};
</script>

<style scoped>
/* =============================================
   AFFILIATION1 — Design system
   ============================================= */
/* Hide sliding panel — replaced by inline top-strip */
.c1-affiliation-page .c1-panel { display: none !important; }
.aff1-main {
  --c1-bg:       #f4f3f0;
  --c1-surface:  #ffffff;
  --c1-surface2: #f4f3f0;
  --c1-border:   #e4e3df;
  --c1-text:     #1a1a1a;
  --c1-muted:    #a09e98;
  --c1-accent:   #7c5cfc;
  --c1-accent2:  #6366f1;
  --c1-dp:       #7c5cfc;
  --c1-ld:       #d4a017;
  --c1-na:       #e05a3a;
  --c1-sc:       #e8891c;
  --c1-rf:       #c75450;
  --c1-ni:       #7a7067;
  --c1-card:     var(--c1-surface);
  --c1-brd:      var(--c1-border);
  --c1-brd-l:    #eeedea;
  --c1-t1:       var(--c1-text);
  --c1-t2:       #6b6963;
  --c1-t3:       #a09e98;
  --c1-act:      rgba(0,0,0,.05);
  --c1-ac:       var(--c1-dp);
  --c1-bn:       var(--c1-ni);
  --aff1-t3:     #a09e98;
  --aff1-unique: var(--c1-accent);
  --aff1-dup:    var(--c1-ld);
  --aff1-conv:   #22c55e;
  background: var(--c1-bg);
  color: var(--c1-text);
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

/* ---- TOAST ---- */
.aff1-toast {
  position: fixed; bottom: 28px; left: 50%; transform: translateX(-50%);
  z-index: 99999; padding: 10px 22px; border-radius: 24px; color: #fff;
  font-size: .85rem; font-weight: 600; box-shadow: 0 4px 20px rgba(0,0,0,.25);
  pointer-events: none; white-space: nowrap; height: auto;
  display: inline-flex; align-items: center;
}
.aff1-toast-fade-enter-active, .aff1-toast-fade-leave-active { transition: opacity .25s, transform .25s; }
.aff1-toast-fade-enter, .aff1-toast-fade-leave-to { opacity: 0; transform: translateX(-50%) translateY(10px); }

/* ---- SDK BANNER ---- */
.aff1-sdk-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: rgba(245,158,11,.1);
  border-bottom: 1px solid rgba(245,158,11,.25);
  font-size: 11px;
  font-weight: 600;
  color: #f59e0b;
  flex-shrink: 0;
}
.aff1-sdk-banner svg { width: 14px; height: 14px; stroke: #f59e0b; fill: none; stroke-width: 2; flex-shrink: 0; }
.aff1-sdk-banner-close {
  margin-left: auto;
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  color: #f59e0b;
  opacity: .7;
}
.aff1-sdk-banner-close:hover { opacity: 1; }
.aff1-sdk-banner-close svg { width: 12px; height: 12px; stroke: currentColor; fill: none; stroke-width: 2.5; display: block; }

.aff1-sdk-inline {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: rgba(245,158,11,.08);
  border: 1px solid rgba(245,158,11,.2);
  border-radius: 7px;
  font-size: 10px;
  font-weight: 600;
  color: #f59e0b;
  margin-bottom: 6px;
}
.aff1-sdk-inline svg { width: 12px; height: 12px; stroke: #f59e0b; fill: none; stroke-width: 2; flex-shrink: 0; }

/* ---- TOP BAR ---- */
.aff1-main .c1-tib {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 0 8px;
  height: 44px;
  background: var(--c1-card);
  border-bottom: 1px solid var(--c1-brd);
  flex-shrink: 0;
}
.aff1-main .c1-tib-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  color: var(--c1-t2);
  cursor: pointer;
  transition: all .12s;
  position: relative;
}
.aff1-main .c1-tib-btn svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; flex-shrink: 0; }
.aff1-main .c1-tib-btn:hover { background: var(--c1-act); color: var(--c1-t1); }
.aff1-main .c1-tib-btn.on { background: var(--c1-act); color: var(--c1-dp); }
.aff1-main .c1-tib-btn.on svg { stroke: var(--c1-dp); }
.c1-tib-badge {
  position: absolute;
  top: 2px; right: 2px;
  background: var(--c1-na);
  color: #fff;
  font-size: 8px;
  font-weight: 800;
  min-width: 14px;
  height: 14px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
}
.aff1-main .c1-tib-user {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: var(--c1-dp);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 800;
  color: #fff;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
}
.aff1-main .c1-tib-user.on { box-shadow: 0 0 0 2px var(--c1-dp); }
.aff1-main .c1-tib-udot {
  position: absolute;
  bottom: 0; right: 0;
  width: 8px; height: 8px;
  border-radius: 50%;
  border: 2px solid var(--c1-card);
  background: var(--c1-t3);
}
.aff1-main .c1-tib-udot.online { background: var(--c1-ac); }
.c1-hp { flex: 1; }
.c1-viki-notif-dot {
  position: absolute;
  top: 4px; right: 4px;
  width: 7px; height: 7px;
  border-radius: 50%;
  background: var(--c1-na);
  border: 1.5px solid var(--c1-card);
}

/* ---- TWO-WAY TOGGLE ---- */
.aff1-view-toggle {
  display: flex;
  background: var(--c1-brd);
  border-radius: 8px;
  padding: 2px;
  gap: 1px;
}
.aff1-vt-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 700;
  color: var(--c1-t3);
  cursor: pointer;
  transition: all .15s;
  user-select: none;
}
.aff1-vt-btn svg { width: 11px; height: 11px; stroke: currentColor; fill: none; stroke-width: 2; }
.aff1-vt-btn.on { background: var(--c1-card); color: var(--c1-dp); box-shadow: 0 1px 4px rgba(0,0,0,.3); }

/* .c1-panel-backdrop — defined globally in c1-design.css */

/* ---- PANELS (global c1-panel handles fixed sliding drawer) ---- */
.c1-panel-hdr-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid var(--c1-brd);
}
.c1-panel-hdr-bar svg { width: 14px; height: 14px; stroke: var(--c1-t3); fill: none; stroke-width: 2; flex-shrink: 0; }
.c1-panel-hdr-ttl { font-size: 12px; font-weight: 700; color: var(--c1-t1); flex: 1; }
.c1-panel-hdr-count { font-size: 10px; color: var(--c1-dp); font-weight: 700; }
.c1-collapse-btn {
  width: 24px; height: 24px;
  display: grid; place-items: center;
  border-radius: 6px;
  cursor: pointer;
  color: var(--c1-t3);
  transition: background .12s;
}
.c1-collapse-btn:hover { background: var(--c1-act); color: var(--c1-t1); }
.c1-collapse-btn svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; }
.aff1-main .c1-sl-body {
  padding: 12px 14px 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.aff1-main .c1-fp-group { margin-bottom: 14px; }
.aff1-main .c1-fp-lbl {
  font-size: 9px; font-weight: 700;
  text-transform: uppercase; letter-spacing: .7px;
  color: var(--c1-t3); margin-bottom: 6px;
}
.aff1-main .c1-fp-opts { display: flex; flex-wrap: wrap; gap: 5px; }
.aff1-main .c1-fp-opt {
  padding: 5px 10px;
  border-radius: 20px;
  border: 1px solid var(--c1-brd);
  font-size: 11px; font-weight: 600;
  color: var(--c1-t2);
  cursor: pointer;
  transition: all .12s;
  white-space: nowrap;
  background: transparent;
  user-select: none;
}
.aff1-main .c1-fp-opt:hover { background: var(--c1-act); color: var(--c1-t1); }
.aff1-main .c1-fp-opt.on { background: var(--c1-dp); border-color: var(--c1-dp); color: #fff; }
.aff1-mock-tag { font-size: 8px; background: rgba(245,158,11,.2); color: #f59e0b; padding: 1px 4px; border-radius: 4px; margin-left: 3px; font-weight: 700; }
.aff1-prov-mock.on { background: #f59e0b !important; border-color: #f59e0b !important; }
.aff1-chip-active.on { background: var(--c1-dp) !important; border-color: var(--c1-dp) !important; }
.aff1-chip-paused.on { background: var(--c1-ld) !important; border-color: var(--c1-ld) !important; }
.aff1-chip-completed.on { background: var(--c1-t3) !important; border-color: var(--c1-t3) !important; }
.aff1-chip-unique.on { background: var(--aff1-unique) !important; border-color: var(--aff1-unique) !important; }
.aff1-chip-dup.on { background: var(--aff1-dup) !important; border-color: var(--aff1-dup) !important; }
.aff1-chip-conv.on { background: var(--aff1-conv) !important; border-color: var(--aff1-conv) !important; }
.c1-fc { margin-left: 4px; opacity: .75; font-size: 10px; }
.c1-fp-full { width: 100%; }
.aff1-main .c1-fp-search {
  position: relative;
  display: flex; align-items: center;
  background: var(--c1-bg);
  border: 1px solid var(--c1-brd);
  border-radius: 8px; overflow: hidden;
}
.c1-fp-sico { position: absolute; left: 10px; width: 14px; height: 14px; stroke: var(--c1-t3); fill: none; stroke-width: 2; stroke-linecap: round; flex-shrink: 0; }
.aff1-main .c1-fp-sinput { flex: 1; border: none; background: transparent; padding: 8px 10px 8px 30px; font-size: 12px; color: var(--c1-t1); outline: none; min-width: 0; }
.aff1-main .c1-fp-sinput::placeholder { color: var(--c1-t3); }
.aff1-main .c1-fp-sclear { padding: 6px 10px; cursor: pointer; color: var(--c1-t3); }
.aff1-main .c1-fp-sclear svg { width: 13px; height: 13px; stroke: currentColor; fill: none; stroke-width: 2; }
.c1-date-range-row { display: flex; align-items: center; gap: 8px; }
.c1-date-input {
  flex: 1; background: var(--c1-bg); border: 1px solid var(--c1-brd);
  border-radius: 7px; padding: 7px 8px; font-size: 11px;
  color: var(--c1-t1); outline: none;
}
.c1-date-input:focus { border-color: var(--c1-dp); }
.c1-date-sep { color: var(--c1-t3); font-size: 12px; flex-shrink: 0; }
.c1-reset-bar {
  display: flex; align-items: center; gap: 8px;
  padding: 8px 14px; background: rgba(239,68,68,.06);
  border-bottom: 1px solid rgba(239,68,68,.15);
  font-size: 11px; font-weight: 600; color: #ef4444;
  cursor: pointer;
}
.c1-reset-bar svg { width: 13px; height: 13px; stroke: currentColor; fill: none; stroke-width: 2; }
.c1-reset-bar-count { background: #ef4444; color: #fff; font-size: 9px; font-weight: 800; padding: 1px 5px; border-radius: 8px; margin-left: auto; }

/* ---- COLLAPSE BAR ---- */
.aff1-main .c1-collapse-bar {
  display: flex; align-items: center; justify-content: center; gap: 6px;
  padding: 8px; border-top: 1px solid var(--c1-brd);
  background: var(--c1-card); color: var(--c1-t3);
  font-size: 11px; font-weight: 600; cursor: pointer;
  transition: color .12s;
}
.aff1-main .c1-collapse-bar:hover { color: var(--c1-t1); }
.aff1-main .c1-collapse-bar svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; }

/* ---- CHARTS PANEL ---- */
.aff1-main .c1-co-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .7px; color: var(--c1-t3); margin-bottom: 8px; }
.aff1-main .c1-vbar-chart { display: flex; flex-direction: column; gap: 5px; }
.aff1-main .c1-vbar-row { display: flex; align-items: center; gap: 8px; }
.aff1-main .c1-vbar-lbl { font-size: 10px; color: var(--c1-t2); width: 60px; flex-shrink: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.aff1-main .c1-vbar-track { flex: 1; height: 16px; background: var(--c1-brd); border-radius: 4px; overflow: hidden; }
.aff1-main .c1-vbar-fill { height: 100%; border-radius: 4px; display: flex; align-items: center; min-width: 24px; transition: width .4s ease; }
.aff1-main .c1-vbar-val { font-size: 9px; font-weight: 700; color: #fff; margin-left: auto; padding-right: 4px; }
.aff1-bar-conv { background: linear-gradient(90deg, #22c55e, #4ade80); }

/* Donut chart */
.aff1-donut-wrap { position: relative; width: 120px; height: 120px; margin: 0 auto 12px; }
.aff1-donut-svg { width: 120px; height: 120px; transform: none; }
.aff1-donut-center { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center; }
.aff1-donut-total { font-size: 20px; font-weight: 800; color: var(--c1-t1); line-height: 1; }
.aff1-donut-lbl { font-size: 9px; color: var(--c1-t3); text-transform: uppercase; letter-spacing: .5px; margin-top: 2px; }
.aff1-donut-legend { display: flex; flex-direction: column; gap: 4px; margin-bottom: 4px; }
.aff1-donut-leg-item { display: flex; align-items: center; gap: 7px; font-size: 10px; }
.aff1-donut-leg-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.aff1-donut-leg-name { flex: 1; color: var(--c1-t2); }
.aff1-donut-leg-val { font-weight: 700; color: var(--c1-t1); }

/* Line charts */
.aff1-line-chart { position: relative; padding: 4px 0 24px; }
.aff1-line-chart svg { width: 100%; height: 60px; display: block; }
.aff1-line-labels { display: flex; justify-content: space-between; margin-top: 4px; }
.aff1-line-lbl { font-size: 9px; color: var(--c1-t3); }
.aff1-chart-empty { font-size: 11px; color: var(--c1-t3); padding: 8px 0; font-style: italic; }

/* Referral timeline */
.aff1-referral-timeline { display: flex; flex-direction: column; gap: 0; }
.aff1-rtl-item { display: flex; align-items: flex-start; gap: 10px; padding: 8px 0; border-bottom: 1px solid var(--c1-brd); }
.aff1-rtl-item:last-child { border-bottom: none; }
.aff1-rtl-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; margin-top: 4px; }
.aff1-rtl-body { flex: 1; min-width: 0; }
.aff1-rtl-title { font-size: 11px; font-weight: 600; color: var(--c1-t1); line-height: 1.3; }
.aff1-rtl-sub { font-size: 9px; color: var(--c1-t3); margin-top: 2px; }
.aff1-rtl-time { font-size: 9px; color: var(--c1-t3); flex-shrink: 0; margin-top: 2px; }

/* ---- VIKI PANEL ---- */
.aff1-viki-card {
  display: flex; align-items: flex-start; gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid var(--c1-brd);
  margin-bottom: 8px;
  background: var(--c1-surface2);
}
.aff1-viki-lead { border-color: rgba(34,197,94,.2); }
.aff1-viki-alert { border-color: rgba(239,68,68,.2); background: rgba(239,68,68,.05); }
.aff1-viki-info { border-color: rgba(99,102,241,.2); }
.aff1-viki-icon { width: 28px; height: 28px; border-radius: 8px; background: var(--c1-brd); display: grid; place-items: center; flex-shrink: 0; }
.aff1-viki-icon svg { width: 14px; height: 14px; stroke: var(--c1-t2); fill: none; stroke-width: 2; }
.aff1-viki-lead .aff1-viki-icon { background: rgba(34,197,94,.12); }
.aff1-viki-lead .aff1-viki-icon svg { stroke: #22c55e; }
.aff1-viki-alert .aff1-viki-icon { background: rgba(239,68,68,.12); }
.aff1-viki-alert .aff1-viki-icon svg { stroke: #ef4444; }
.aff1-viki-info .aff1-viki-icon { background: rgba(99,102,241,.12); }
.aff1-viki-info .aff1-viki-icon svg { stroke: #6366f1; }
.aff1-viki-body { flex: 1; min-width: 0; }
.aff1-viki-msg { font-size: 11px; font-weight: 600; color: var(--c1-t1); line-height: 1.4; }
.aff1-viki-time { font-size: 9px; color: var(--c1-t3); margin-top: 3px; }
.aff1-viki-dismiss {
  background: none; border: none; cursor: pointer;
  padding: 4px; color: var(--c1-t3); flex-shrink: 0;
}
.aff1-viki-dismiss:hover { color: var(--c1-t1); }
.aff1-viki-dismiss svg { width: 12px; height: 12px; stroke: currentColor; fill: none; stroke-width: 2.5; display: block; }

/* ---- CALENDAR ---- */
.aff1-cal-hdr { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; }
.aff1-cal-title { font-size: 13px; font-weight: 700; color: var(--c1-t1); }
.aff1-cal-nav { background: var(--c1-brd); border: none; border-radius: 6px; width: 28px; height: 28px; cursor: pointer; display: flex; align-items: center; justify-content: center; color: var(--c1-t2); }
.aff1-cal-nav:hover { background: var(--c1-act); color: var(--c1-dp); }
.aff1-cal-nav svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; }
.aff1-cal-dow { display: grid; grid-template-columns: repeat(7,1fr); gap: 2px; margin-bottom: 4px; }
.aff1-cal-dow span { text-align: center; font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--c1-t3); padding: 3px 0; }
.aff1-cal-grid { display: grid; grid-template-columns: repeat(7,1fr); gap: 2px; }
.aff1-cal-day { position: relative; aspect-ratio: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; border-radius: 6px; cursor: pointer; font-size: 11px; font-weight: 500; color: var(--c1-t1); transition: background .1s; }
.aff1-cal-day:hover { background: var(--c1-act); }
.aff1-cal-day.other-month { color: var(--c1-t3); }
.aff1-cal-day.today { background: rgba(99,102,241,.15); color: var(--c1-dp); font-weight: 700; }
.aff1-cal-day.selected { background: var(--c1-dp); color: #fff; }
.aff1-cal-day.heat-high { background: rgba(34,197,94,.18); }
.aff1-cal-day.heat-mid { background: rgba(245,158,11,.12); }
.aff1-cal-day.heat-low { background: rgba(239,68,68,.12); }
.aff1-cal-dot { position: absolute; bottom: 2px; width: 4px; height: 4px; border-radius: 50%; background: var(--aff1-conv); }
.aff1-cal-day-detail { margin-top: 12px; }
.aff1-cal-day-kpis { display: flex; gap: 0; margin-bottom: 10px; }
.aff1-cal-dk { flex: 1; text-align: center; border-right: 1px solid var(--c1-brd); }
.aff1-cal-dk:last-child { border-right: none; }
.aff1-cal-dk-val { font-size: 18px; font-weight: 800; color: var(--c1-t1); line-height: 1; }
.aff1-cal-dk-lbl { font-size: 8px; color: var(--c1-t3); text-transform: uppercase; letter-spacing: .5px; margin-top: 3px; }
.aff1-cal-click-row { display: flex; align-items: center; gap: 8px; padding: 6px 0; border-bottom: 1px solid var(--c1-brd); font-size: 11px; }
.aff1-cal-click-row:last-child { border-bottom: none; }

/* ---- MENU PANEL ---- */
.aff1-menu-panel { top: 44px; background: var(--c1-bg) !important; position: relative; z-index: 100; }
.aff1-main .c1-prof-head { background: var(--c1-card); border-bottom: 1px solid var(--c1-brd); padding: 14px; }
.aff1-main .c1-prof-brand-row { display: flex; align-items: center; margin-bottom: 12px; }
.aff1-main .c1-prof-brand-name { font-size: 14px; font-weight: 800; color: var(--c1-t1); }
.aff1-main .c1-prof-brand-name span { color: var(--c1-dp); }
.aff1-main .c1-tz-row { display: flex; gap: 12px; }
.aff1-main .c1-tz { display: flex; gap: 5px; align-items: center; }
.aff1-main .c1-tz-lbl { font-size: 9px; color: var(--c1-t3); font-weight: 700; }
.aff1-main .c1-tz-t { font-size: 11px; color: var(--c1-t1); font-family: 'JetBrains Mono', monospace; }
.aff1-main .c1-prof-user-row { display: flex; align-items: center; gap: 10px; }
.aff1-main .c1-prof-av { width: 36px; height: 36px; border-radius: 50%; background: var(--c1-dp); display: grid; place-items: center; font-size: 13px; font-weight: 800; color: #fff; flex-shrink: 0; }
.aff1-main .c1-prof-meta { flex: 1; min-width: 0; }
.aff1-main .c1-prof-name { font-size: 13px; font-weight: 700; color: var(--c1-t1); }
.aff1-main .c1-prof-role { font-size: 10px; color: var(--c1-t3); margin-top: 1px; }
.aff1-main .c1-prof-toggle { display: flex; align-items: center; gap: 5px; border: 1px solid var(--c1-brd); border-radius: 20px; padding: 4px 8px; cursor: pointer; font-size: 10px; font-weight: 600; color: var(--c1-t3); }
.aff1-main .c1-prof-toggle.online { border-color: var(--c1-ac); color: var(--c1-ac); background: rgba(34,197,94,.08); }
.aff1-main .c1-prof-tog-dot { width: 6px; height: 6px; border-radius: 50%; background: currentColor; }
.aff1-main .c1-prof-scroll { background: var(--c1-bg); padding: 10px; }
.aff1-main .c1-nc-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .7px; color: var(--c1-t3); padding: 6px 4px 4px; }
.aff1-main .c1-ng { display: flex; flex-direction: column; gap: 3px; margin-bottom: 8px; }
.aff1-main .c1-nb { display: flex; align-items: center; gap: 8px; padding: 9px 12px; border-radius: 8px; border: 1px solid transparent; font-size: 12px; font-weight: 600; cursor: pointer; text-decoration: none; transition: all .12s; }
.aff1-main .c1-nb svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; flex-shrink: 0; }
.aff1-main .c1-nb-dp { background: rgba(99,102,241,.12); color: var(--c1-dp); }
.aff1-main .c1-nb-dp:hover, .aff1-main .c1-nb-dp.router-link-exact-active { border-color: var(--c1-dp); }
.aff1-main .c1-nb-aff { background: rgba(99,102,241,.18); color: var(--c1-dp); font-weight: 700; }
.aff1-main .c1-nb-aff:hover, .aff1-main .c1-nb-aff.router-link-exact-active { border-color: var(--c1-dp); box-shadow: 0 0 0 2px rgba(99,102,241,.2); }
.aff1-main .c1-nb-logout { background: rgba(239,68,68,.1); color: #ef4444; }
.aff1-main .c1-nb-logout:hover { border-color: #ef4444; }
.aff1-main .c1-collapse-bar-lg { border-top: 1px solid var(--c1-brd); color: var(--c1-t3); background: transparent; margin-top: 8px; }

/* ---- VIEW MODE BAR ---- */
.aff1-view-mode-bar {
  display: flex; align-items: center; gap: 10px;
  padding: 7px 12px;
  background: var(--c1-surface2);
  border-bottom: 1px solid var(--c1-brd);
  flex-shrink: 0;
}
.aff1-vm-pill {
  display: flex; align-items: center; gap: 6px;
  font-size: 11px; font-weight: 600;
  padding: 4px 10px; border-radius: 20px;
}
.aff1-vm-pill svg { width: 12px; height: 12px; stroke: currentColor; fill: none; stroke-width: 2; }
.aff1-vm-in { background: rgba(34,197,94,.1); color: #22c55e; }
.aff1-vm-out { background: rgba(99,102,241,.12); color: var(--c1-dp); }
.aff1-add-prov-btn {
  margin-left: auto;
  display: flex; align-items: center; gap: 5px;
  padding: 5px 12px;
  border-radius: 8px;
  border: 1px solid var(--c1-brd);
  background: transparent;
  color: var(--c1-t2);
  font-size: 11px; font-weight: 600;
  cursor: pointer;
  transition: all .12s;
}
.aff1-add-prov-btn svg { width: 12px; height: 12px; stroke: currentColor; fill: none; stroke-width: 2.5; }
.aff1-add-prov-btn:hover { background: var(--c1-act); border-color: var(--c1-dp); color: var(--c1-dp); }

/* ---- SUMMARY STRIP ---- */
.aff1-summary-strip {
  display: flex; align-items: stretch; gap: 0;
  background: var(--c1-card);
  border-bottom: 1px solid var(--c1-brd);
  flex-shrink: 0; overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.aff1-kpi { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 10px 8px; border-right: 1px solid var(--c1-brd); min-width: 60px; }
.aff1-kpi:last-child { border-right: none; }
.aff1-kpi-val { font-size: 17px; font-weight: 800; color: var(--c1-t1); line-height: 1; letter-spacing: -.5px; }
.aff1-kpi-lbl { font-size: 8px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--c1-t3); margin-top: 3px; white-space: nowrap; }
.aff1-kpi-unique { color: var(--aff1-unique); }
.aff1-kpi-conv { color: var(--aff1-conv); }
.aff1-kpi-rate { color: var(--c1-sc); }
.aff1-kpi-prov-name { font-size: 11px; font-weight: 700; color: var(--c1-dp); }
.aff1-kpi-provider { flex: 1.5; }

/* ---- PROVIDER TABLE ---- */
.aff1-provider-table {
  flex: 1; overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.aff1-pt-hdr {
  display: flex; align-items: center;
  padding: 7px 12px;
  background: var(--c1-surface2);
  border-bottom: 1px solid var(--c1-brd);
  position: sticky; top: 0; z-index: 10;
}
.aff1-pt-hc {
  font-size: 9px; font-weight: 700;
  text-transform: uppercase; letter-spacing: .6px;
  color: var(--c1-t3);
}
.aff1-pt-hc-prov { flex: 1; min-width: 0; }
.aff1-pt-hc:not(.aff1-pt-hc-prov):not(.aff1-pt-hc-chv) { width: 52px; text-align: center; flex-shrink: 0; }
.aff1-pt-hc-chv { width: 20px; flex-shrink: 0; }

.aff1-pt-block { border-bottom: 1px solid var(--c1-brd); background: var(--c1-card); transition: background .12s; }
.aff1-pt-block.expanded { background: var(--c1-surface2); }
.aff1-pt-row {
  display: flex; align-items: center;
  padding: 11px 12px;
  cursor: pointer;
  transition: background .1s;
  min-height: 52px;
}
.aff1-pt-row:hover { background: rgba(99,102,241,.04); }
.aff1-pt-c { }
.aff1-pt-c-prov { flex: 1; min-width: 0; display: flex; align-items: center; gap: 9px; }
.aff1-pt-c-num { width: 52px; text-align: center; flex-shrink: 0; font-size: 13px; font-weight: 700; color: var(--c1-t1); }
.aff1-pt-c-chv { width: 20px; flex-shrink: 0; display: flex; justify-content: center; }

.aff1-prov-logo-lg {
  width: 32px; height: 32px;
  border-radius: 9px;
  background: var(--c1-surface2);
  border: 1px solid var(--c1-brd);
  display: flex; align-items: center; justify-content: center;
  font-size: 14px; font-weight: 900;
  color: var(--c1-t1);
  flex-shrink: 0;
}
.aff1-prov-logo { font-size: 12px; font-weight: 800; }
.aff1-prov-info { flex: 1; min-width: 0; }
.aff1-prov-name { font-size: 12px; font-weight: 700; color: var(--c1-t1); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.aff1-prov-type { font-size: 9px; color: var(--c1-t3); text-transform: uppercase; letter-spacing: .5px; margin-top: 1px; }
.aff1-mock-badge { font-size: 8px; background: rgba(245,158,11,.15); color: #f59e0b; padding: 2px 5px; border-radius: 4px; font-weight: 700; flex-shrink: 0; }
.aff1-prov-status-pill { font-size: 8px; font-weight: 700; padding: 2px 6px; border-radius: 8px; flex-shrink: 0; text-transform: uppercase; }
.aff1-ps-active { background: rgba(34,197,94,.12); color: #22c55e; }
.aff1-ps-paused { background: rgba(245,158,11,.12); color: #f59e0b; }
.aff1-cpl-spike { color: #ef4444 !important; }
.aff1-spike-arrow { font-size: 9px; font-weight: 700; color: #ef4444; display: block; margin-top: 1px; }

/* ---- EXPANDED PROVIDER DETAIL ---- */
.aff1-pt-expanded { padding: 0 12px 12px; border-top: 1px solid var(--c1-brd); }
.aff1-exp-tabs { display: flex; gap: 0; border-bottom: 1px solid var(--c1-brd); margin-bottom: 0; }
.aff1-exp-tab {
  padding: 8px 12px; font-size: 11px; font-weight: 600;
  color: var(--c1-t3); cursor: pointer;
  border-bottom: 2px solid transparent; transition: all .12s;
  white-space: nowrap;
}
.aff1-exp-tab:hover { color: var(--c1-t1); }
.aff1-exp-tab.on { color: var(--c1-dp); border-bottom-color: var(--c1-dp); }

/* Sub-table */
.aff1-sub-table { margin-top: 0; }
.aff1-sub-hdr {
  display: flex; padding: 7px 12px;
  background: var(--c1-bg);
  border-bottom: 1px solid var(--c1-brd);
}
.aff1-sub-hc { font-size: 8px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--c1-t3); width: 50px; text-align: center; flex-shrink: 0; }
.aff1-sub-hc:first-child { text-align: left; }
.aff1-sub-row { display: flex; align-items: center; padding: 7px 12px; border-bottom: 1px solid var(--c1-brd); }
.aff1-sub-row:last-child { border-bottom: none; }
.aff1-sub-c { width: 50px; text-align: center; flex-shrink: 0; font-size: 11px; color: var(--c1-t1); font-weight: 500; }
.aff1-sub-c-name { text-align: left; display: flex; align-items: center; gap: 7px; color: var(--c1-t1); font-size: 11px; }
.aff1-sub-c-kw { text-align: left; display: flex; align-items: center; gap: 7px; font-size: 11px; color: var(--c1-t2); }
.aff1-camp-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--c1-dp); flex-shrink: 0; }
.aff1-kw-rank { font-size: 9px; font-weight: 700; color: var(--c1-t3); width: 16px; flex-shrink: 0; }

/* Cost analysis */
.aff1-cost-panel { padding: 12px; }
.aff1-cost-kpi-row { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-bottom: 14px; }
.aff1-cost-kpi { text-align: center; }
.aff1-cost-kpi-val { font-size: 17px; font-weight: 800; color: var(--c1-t1); line-height: 1; }
.aff1-cost-kpi-lbl { font-size: 8px; color: var(--c1-t3); text-transform: uppercase; letter-spacing: .4px; margin-top: 3px; }
.aff1-color-spend { color: #ef4444; }
.aff1-cost-bar-wrap { }
.aff1-cost-bar-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--c1-t3); margin-bottom: 8px; }
.aff1-cost-comparison { display: flex; flex-direction: column; gap: 4px; margin-bottom: 6px; }
.aff1-cost-track { height: 12px; background: var(--c1-brd); border-radius: 6px; overflow: hidden; }
.aff1-cost-fill { height: 100%; border-radius: 6px; transition: width .5s ease; }
.aff1-cost-spend-fill { background: linear-gradient(90deg, #ef4444, #f97316); }
.aff1-cost-rev-fill { background: linear-gradient(90deg, #22c55e, #4ade80); }
.aff1-cost-legend { display: flex; gap: 14px; font-size: 10px; color: var(--c1-t2); }
.aff1-cost-leg-dot { width: 8px; height: 8px; border-radius: 2px; display: inline-block; margin-right: 4px; }
.aff1-color-spend-dot { background: #ef4444; }
.aff1-color-rev-dot { background: #22c55e; }

/* Trend panel */
.aff1-trend-panel { padding: 12px; }

/* Provider action buttons */
.aff1-pt-actions { display: flex; gap: 8px; margin-top: 10px; padding: 10px 0 2px; border-top: 1px solid var(--c1-brd); }

/* ---- CLICK LIST (outbound view) ---- */
.aff1-list { flex: 1; overflow-y: auto; -webkit-overflow-scrolling: touch; }
.aff1-box { background: var(--c1-card); border-bottom: 1px solid var(--c1-brd); transition: background .12s; }
.aff1-box.expanded { background: var(--c1-surface2); }
.aff1-row { display: flex; align-items: center; gap: 6px; padding: 10px 12px; cursor: pointer; transition: background .1s; min-height: 46px; }
.aff1-row:hover { background: rgba(99,102,241,.04); }
.aff1-col-ts { display: flex; flex-direction: column; width: 50px; flex-shrink: 0; }
.aff1-mono { font-family: 'JetBrains Mono', monospace; font-size: 10px; }
.aff1-ago { font-size: 9px; color: var(--c1-t3); margin-top: 1px; }
.aff1-col-prov { flex: 1; min-width: 0; }
.aff1-col-type { flex-shrink: 0; }
.aff1-col-ip { display: flex; align-items: center; gap: 3px; flex-shrink: 0; }
.aff1-ip { font-size: 9px; color: var(--c1-t2); max-width: 80px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.aff1-flag { font-size: 13px; line-height: 1; }
.aff1-col-status { flex-shrink: 0; }
.aff1-col-chv { flex-shrink: 0; width: 16px; }
.aff1-chv { width: 14px; height: 14px; stroke: var(--c1-t3); fill: none; stroke-width: 2; transition: transform .2s; }
.aff1-chv.open { transform: rotate(180deg); }

/* Provider chip */
.aff1-provider-chip-sm {
  display: inline-block; padding: 2px 7px; border-radius: 10px;
  background: rgba(99,102,241,.15); color: var(--c1-dp);
  font-size: 10px; font-weight: 700; white-space: nowrap;
  overflow: hidden; text-overflow: ellipsis; max-width: 90px; vertical-align: middle;
}

/* Type badges */
.aff1-type-badge { display: inline-block; padding: 2px 6px; border-radius: 4px; font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .4px; }
.aff1-ct-organic { background: rgba(34,197,94,.12); color: var(--aff1-conv); }
.aff1-ct-paid { background: rgba(245,158,11,.12); color: var(--c1-sc); }
.aff1-ct-referral { background: rgba(99,102,241,.15); color: var(--c1-dp); }

/* Status badges */
.aff1-status-badge { display: inline-block; padding: 2px 8px; border-radius: 10px; font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .3px; white-space: nowrap; }
.aff1-s-unique { background: rgba(99,102,241,.15); color: var(--aff1-unique); }
.aff1-s-duplicate { background: rgba(245,158,11,.12); color: var(--c1-sc); }
.aff1-s-converted { background: rgba(34,197,94,.12); color: var(--aff1-conv); }
.aff1-s-active { background: rgba(34,197,94,.12); color: var(--aff1-conv); }
.aff1-s-paused { background: rgba(245,158,11,.12); color: #f59e0b; }
.aff1-s-completed { background: rgba(100,116,139,.12); color: var(--c1-t3); }

/* ---- EXPANDED CLICK ---- */
.aff1-expanded { padding: 0 12px 12px; }
.aff1-exp-sec { margin-bottom: 12px; padding-top: 10px; border-top: 1px solid var(--c1-brd); }
.aff1-exp-sec:first-child { border-top: none; }
.aff1-exp-sec-conv { background: rgba(34,197,94,.04); border-radius: 8px; padding: 8px; border: 1px solid rgba(34,197,94,.15); margin-bottom: 12px; }
.aff1-exp-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .7px; color: var(--c1-t3); margin-bottom: 8px; }
.aff1-exp-lbl-conv { color: var(--aff1-conv); }
.aff1-exp-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; }
.aff1-ef { display: flex; flex-direction: column; gap: 2px; }
.aff1-ef-full { grid-column: 1 / -1; }
.aff1-ef-l { font-size: 9px; color: var(--c1-t3); font-weight: 600; text-transform: uppercase; letter-spacing: .3px; }
.aff1-ef-v { font-size: 11px; color: var(--c1-t1); font-weight: 500; }
.aff1-exp-actions { display: flex; gap: 8px; margin-top: 10px; }

/* ---- ACTION BUTTONS ---- */
.aff1-action-btn { display: flex; align-items: center; gap: 5px; padding: 7px 12px; border-radius: 8px; border: 1px solid var(--c1-brd); background: transparent; color: var(--c1-t2); font-size: 11px; font-weight: 600; cursor: pointer; transition: all .12s; }
.aff1-action-btn svg { width: 13px; height: 13px; stroke: currentColor; fill: none; stroke-width: 2; flex-shrink: 0; }
.aff1-action-detail:hover { background: rgba(99,102,241,.12); border-color: var(--c1-dp); color: var(--c1-dp); }
.aff1-action-provider:hover { background: rgba(34,197,94,.08); border-color: var(--aff1-conv); color: var(--aff1-conv); }

/* ---- SECTION DIVIDERS ---- */
.aff1-section-divider {
  display: flex; align-items: center; gap: 10px;
  padding: 10px 14px;
  background: var(--c1-surface2);
  border-top: 1px solid var(--c1-brd);
  border-bottom: 1px solid var(--c1-brd);
}
.aff1-section-divider span { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .7px; color: var(--c1-t3); }

/* ---- REFERRAL SECTION ---- */
.aff1-referral-section { padding: 12px; }
.aff1-referral-hdr { margin-bottom: 12px; }
.aff1-referral-hdr-ttl { font-size: 13px; font-weight: 700; color: var(--c1-t1); }
.aff1-referral-hdr-sub { font-size: 10px; color: var(--c1-t3); margin-top: 2px; }
.aff1-ref-row { display: flex; align-items: center; gap: 10px; padding: 9px 0; border-bottom: 1px solid var(--c1-brd); }
.aff1-ref-row:last-child { border-bottom: none; }
.aff1-ref-av { width: 32px; height: 32px; border-radius: 50%; background: var(--c1-dp); display: grid; place-items: center; font-size: 11px; font-weight: 800; color: #fff; flex-shrink: 0; }
.aff1-ref-info { flex: 1; min-width: 0; }
.aff1-ref-name { font-size: 12px; font-weight: 600; color: var(--c1-t1); }
.aff1-ref-chain { font-size: 9px; color: var(--c1-t3); margin-top: 1px; }
.aff1-ref-stats { display: flex; gap: 14px; flex-shrink: 0; }
.aff1-ref-stat { text-align: center; }
.aff1-ref-stat-val { font-size: 15px; font-weight: 800; color: var(--c1-t1); line-height: 1; }
.aff1-ref-stat-lbl { font-size: 8px; color: var(--c1-t3); text-transform: uppercase; letter-spacing: .4px; margin-top: 2px; }

/* ---- PIXEL SECTION ---- */
.aff1-pixel-section { padding: 12px; }
.aff1-pixel-hdr-row { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; }
.aff1-pixel-hdr-info { flex: 1; }
.aff1-pixel-hdr-ttl { font-size: 13px; font-weight: 700; color: var(--c1-t1); }
.aff1-pixel-hdr-sub { font-size: 10px; color: var(--c1-t3); margin-top: 2px; }
.aff1-pixel-row { display: flex; align-items: center; gap: 10px; padding: 9px 0; border-bottom: 1px solid var(--c1-brd); }
.aff1-pixel-row:last-child { border-bottom: none; }
.aff1-pixel-row-prov { display: flex; align-items: flex-start; gap: 9px; flex: 1; min-width: 0; }
.aff1-pixel-row-info { flex: 1; min-width: 0; }
.aff1-pixel-row-name { font-size: 12px; font-weight: 600; color: var(--c1-t1); }
.aff1-pixel-row-stats { display: flex; flex-direction: column; gap: 3px; text-align: right; flex-shrink: 0; }
.aff1-px-stat { font-size: 10px; font-weight: 600; color: var(--c1-t2); display: flex; align-items: center; gap: 4px; }
.aff1-px-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }
.aff1-px-active { background: var(--c1-dp); }
.aff1-px-inactive { background: var(--c1-t3); }

/* ---- EMPTY / LOADING ---- */
.aff1-empty { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 60px 20px; text-align: center; }
.aff1-empty-icon { width: 48px; height: 48px; border-radius: 14px; background: var(--c1-brd); display: grid; place-items: center; margin-bottom: 12px; }
.aff1-empty-icon svg { width: 24px; height: 24px; stroke: var(--c1-t3); fill: none; stroke-width: 1.8; }
.aff1-empty-msg { font-size: 13px; font-weight: 600; color: var(--c1-t2); }
.aff1-empty-sub { font-size: 11px; color: var(--c1-t3); margin-top: 4px; }
.c1-loading { display: flex; flex-direction: column; align-items: center; justify-content: center; flex: 1; padding: 60px 20px; }
.c1-spinner { width: 24px; height: 24px; border-radius: 50%; border: 2px solid var(--c1-brd); border-top-color: var(--c1-dp); animation: aff1spin .7s linear infinite; }
.aff1-loading-lbl { font-size: 11px; color: var(--c1-t3); margin-top: 8px; }
@keyframes aff1spin { to { transform: rotate(360deg); } }

/* ---- DRAWERS ---- */
.aff1-drawer-wrap { position: fixed; inset: 0; background: rgba(0,0,0,.55); z-index: 400; display: flex; justify-content: flex-end; }
.aff1-drawer-left-variant { justify-content: flex-start; }
.aff1-drawer { width: min(380px,95vw); height: 100%; background: #16162a; border-left: 1px solid var(--c1-brd); display: flex; flex-direction: column; overflow: hidden; }
.aff1-drawer.aff1-drawer-left { border-left: none; border-right: 1px solid var(--c1-brd); }
.aff1-drawer-head { display: flex; align-items: center; gap: 10px; padding: 14px 14px 12px; border-bottom: 1px solid var(--c1-brd); flex-shrink: 0; background: var(--c1-card, #fff); }
.aff1-drawer-av { width: 36px; height: 36px; border-radius: 10px; background: rgba(99,102,241,.2); display: grid; place-items: center; flex-shrink: 0; color: var(--c1-dp); }
.aff1-drawer-av svg { width: 18px; height: 18px; }
.aff1-drawer-av-prov { background: rgba(34,197,94,.12); color: var(--aff1-conv); }
.aff1-drawer-title { flex: 1; min-width: 0; }
.aff1-drawer-name { font-size: 13px; font-weight: 700; color: var(--c1-t1); }
.aff1-drawer-sub { font-size: 10px; color: var(--c1-t3); margin-top: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.aff1-drawer-close { background: none; border: none; cursor: pointer; padding: 6px; border-radius: 6px; color: var(--c1-t3); transition: background .12s; flex-shrink: 0; }
.aff1-drawer-close:hover { background: var(--c1-act); color: var(--c1-t1); }
.aff1-drawer-close svg { width: 16px; height: 16px; display: block; }
.aff1-drawer-body { flex: 1; overflow-y: auto; -webkit-overflow-scrolling: touch; padding: 14px; }

/* Transitions */
.aff1-drawer-enter-active, .aff1-drawer-leave-active { transition: transform .24s cubic-bezier(.4,0,.2,1), opacity .2s; }
.aff1-drawer-enter, .aff1-drawer-leave-to { transform: translateX(100%); opacity: 0; }
.aff1-drawer-left-enter-active, .aff1-drawer-left-leave-active { transition: transform .24s cubic-bezier(.4,0,.2,1), opacity .2s; }
.aff1-drawer-left-enter, .aff1-drawer-left-leave-to { transform: translateX(-100%); opacity: 0; }

/* ---- FORMS ---- */
.aff1-form-group { margin-bottom: 12px; }
.aff1-form-lbl { display: block; font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--c1-t3); margin-bottom: 5px; }
.aff1-form-input { width: 100%; box-sizing: border-box; background: var(--c1-bg); border: 1px solid var(--c1-brd); border-radius: 8px; padding: 8px 10px; font-size: 12px; color: var(--c1-t1); outline: none; transition: border-color .12s; }
.aff1-form-input:focus { border-color: var(--c1-dp); }
.aff1-form-input::placeholder { color: var(--c1-t3); }
.aff1-form-select { width: 100%; box-sizing: border-box; background: var(--c1-bg); border: 1px solid var(--c1-brd); border-radius: 8px; padding: 8px 10px; font-size: 12px; color: var(--c1-t1); outline: none; cursor: pointer; appearance: none; }
.aff1-form-select:focus { border-color: var(--c1-dp); }
.aff1-submit-btn { display: flex; align-items: center; justify-content: center; gap: 6px; width: 100%; padding: 10px 14px; background: var(--c1-dp); border: none; border-radius: 8px; color: #fff; font-size: 12px; font-weight: 700; cursor: pointer; transition: opacity .12s; margin-top: 4px; }
.aff1-submit-btn:disabled { opacity: .4; cursor: default; }
.aff1-submit-btn:not(:disabled):hover { opacity: .9; }
.aff1-submit-btn svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2.5; }

/* Pixel output */
.aff1-pixel-output { margin-top: 10px; padding: 10px; background: var(--c1-bg); border: 1px solid var(--c1-brd); border-radius: 8px; }
.aff1-pixel-url { color: var(--c1-t2); line-height: 1.5; }
.aff1-copy-btn { display: inline-flex; align-items: center; gap: 5px; margin-top: 8px; padding: 5px 10px; background: var(--c1-brd); border: none; border-radius: 6px; font-size: 10px; font-weight: 700; color: var(--c1-t2); cursor: pointer; transition: all .12s; }
.aff1-copy-btn:hover { background: var(--c1-act); color: var(--c1-dp); }
.aff1-copy-btn svg { width: 12px; height: 12px; stroke: currentColor; fill: none; stroke-width: 2; }

/* ---- RESPONSIVE ---- */
@media (min-width: 480px) {
  .aff1-row { padding: 12px 16px; }
  .aff1-col-ts { width: 65px; }
  .aff1-ip { max-width: 110px; }
  .aff1-provider-chip-sm { max-width: 120px; }
  .aff1-kpi-val { font-size: 19px; }
}
@media (min-width: 768px) {
  .aff1-col-ts { width: 80px; }
  .aff1-ip { max-width: 130px; }
  .aff1-provider-chip-sm { max-width: 150px; }
  .aff1-pt-c-num { width: 70px; }
  .aff1-pt-hc:not(.aff1-pt-hc-prov):not(.aff1-pt-hc-chv) { width: 70px; }
  .aff1-summary-strip { justify-content: stretch; }
}
</style>
